(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wetu-command-center-product-hydrator-script"] && !Shopify.designMode) return;
  try {
    (() => {
  const ROOT_SELECTOR = ".itin-command-center[data-section-id]";
  const INSPECTOR_BODY_SELECTOR = "[data-command-center-inspector-body]";
  const JOURNEY_TAB_ACTIVE_SELECTOR =
    '[data-command-center-journey-tab][aria-selected="true"]';
  const PANEL_CLASS = "wetu-command-center-panel";
  const PANEL_VIEW = "wetu-command-center-panel";
  const MAP_OWNED_VIEWS = new Set(["overview", "route"]);

  const cacheByRoot = new WeakMap();
  const inflightByRoot = new WeakMap();
  const payloadKeyByRoot = new WeakMap();
  const frameByRoot = new WeakMap();
  const signatureByRoot = new WeakMap();
  const observerByRoot = new WeakMap();
  const pollerByRoot = new WeakMap();

  const normalizeText = (value) =>
    String(value || "")
      .replace(/\s+/g, " ")
      .trim();

  const getActiveJourneyView = (root) => {
    if (!(root instanceof HTMLElement)) return "";
    const activeTab = root.querySelector(JOURNEY_TAB_ACTIVE_SELECTOR);
    if (!(activeTab instanceof HTMLElement)) return "";
    return normalizeText(
      activeTab.getAttribute("data-command-center-journey-tab"),
    ).toLowerCase();
  };

  const isMapOwnedView = (root) =>
    MAP_OWNED_VIEWS.has(getActiveJourneyView(root));

  const ensurePanelFetchDedupe = () => {
    if (window.__wetuPanelFetchDedupeInstalled) return;
    if (typeof window.fetch !== "function") return;

    const nativeFetch = window.fetch.bind(window);
    const sharedByKey = new Map();

    const canonicalKeyForPanel = (url) => {
      const text = normalizeText(url);
      if (!text) return "";
      try {
        const parsed = new URL(text, window.location.origin);
        if (
          normalizeText(parsed.searchParams.get("view")).toLowerCase() !==
          PANEL_VIEW
        )
          return "";
        const parts = [];
        parsed.searchParams.forEach((value, key) => {
          parts.push([key, value]);
        });
        parts.sort((a, b) => {
          if (a[0] < b[0]) return -1;
          if (a[0] > b[0]) return 1;
          if (a[1] < b[1]) return -1;
          if (a[1] > b[1]) return 1;
          return 0;
        });
        const sorted = parts
          .map(
            ([key, value]) =>
              `${encodeURIComponent(key)}=${encodeURIComponent(value)}`,
          )
          .join("&");
        return `${parsed.origin}${parsed.pathname}?${sorted}`;
      } catch (_error) {
        return "";
      }
    };

    window.fetch = (input, init) => {
      const method =
        normalizeText(
          init?.method ||
            (input && typeof input === "object" && "method" in input
              ? input.method
              : "GET"),
        ).toUpperCase() || "GET";

      if (method !== "GET") return nativeFetch(input, init);

      const requestUrl = (() => {
        if (typeof input === "string") return input;
        if (input && typeof input === "object" && "url" in input)
          return String(input.url || "");
        return "";
      })();

      const key = canonicalKeyForPanel(requestUrl);
      if (!key) return nativeFetch(input, init);

      const existing = sharedByKey.get(key);
      if (existing?.promise instanceof Promise) {
        return existing.promise.then((response) => response.clone());
      }

      const promise = nativeFetch(input, init).finally(() => {
        window.setTimeout(() => {
          sharedByKey.delete(key);
        }, 140);
      });

      sharedByKey.set(key, { promise });
      return promise.then((response) => response.clone());
    };

    window.__wetuPanelFetchDedupeInstalled = true;
  };

  const withPreviewParams = (url) => {
    try {
      const requestUrl = new URL(url, window.location.origin);
      const currentUrl = new URL(window.location.href);
      const previewThemeId = normalizeText(
        currentUrl.searchParams.get("preview_theme_id"),
      );
      const pb = normalizeText(currentUrl.searchParams.get("pb"));
      if (previewThemeId && !requestUrl.searchParams.has("preview_theme_id")) {
        requestUrl.searchParams.set("preview_theme_id", previewThemeId);
      }
      if (pb && !requestUrl.searchParams.has("pb")) {
        requestUrl.searchParams.set("pb", pb);
      }
      return requestUrl.toString();
    } catch (_error) {
      return String(url || "");
    }
  };

  const getPayload = (root) => {
    const payload = root?.commandCenterState?.activeInspectorPayload;
    if (!payload || typeof payload !== "object") return null;
    if (normalizeText(payload.type).toLowerCase() !== "product") return null;
    return payload;
  };

  const parseHandle = (payload) => {
    const fromPayload = normalizeText(payload?.handle);
    if (fromPayload) return fromPayload;

    const sourceUrl =
      normalizeText(payload?.displayUrl) || normalizeText(payload?.url);
    if (!sourceUrl) return "";

    try {
      const match = new URL(sourceUrl, window.location.origin).pathname.match(
        /^\/products\/([^/?#]+)/i,
      );
      return match ? decodeURIComponent(match[1]) : "";
    } catch (_error) {
      return "";
    }
  };

  const getPayloadKey = (payload) => {
    if (!payload) return "";
    return [
      normalizeText(payload.type).toLowerCase(),
      parseHandle(payload).toLowerCase(),
      normalizeText(payload?.id || payload?.key).toLowerCase(),
      (
        normalizeText(payload?.displayUrl) || normalizeText(payload?.url)
      ).toLowerCase(),
    ]
      .filter(Boolean)
      .join("|");
  };

  const buildInspectorUrl = (payload) => {
    const baseUrl =
      normalizeText(payload?.displayUrl) || normalizeText(payload?.url);
    if (!baseUrl) return "";
    try {
      const url = new URL(baseUrl, window.location.origin);
      url.searchParams.set("view", PANEL_VIEW);
      return withPreviewParams(url.toString());
    } catch (_error) {
      return "";
    }
  };

  const ensureCache = (root) => {
    const existing = cacheByRoot.get(root);
    if (existing instanceof Map) return existing;
    const next = new Map();
    cacheByRoot.set(root, next);
    return next;
  };

  const applyPanelMarkup = (root, inspectorBody, html, payload) => {
    inspectorBody.classList.remove("is-overview-active");
    inspectorBody.removeAttribute("data-command-center-route-placeholder");
    inspectorBody.classList.add("is-product-embed");
    inspectorBody.setAttribute(
      "aria-label",
      normalizeText(payload?.title) || "Selected journey stop",
    );
    inspectorBody.setAttribute("aria-busy", "false");
    inspectorBody.innerHTML = `
      <section class="itin-command-center__inspector-product-surface" data-inspector-product-surface>
        <div class="itin-command-center__inspector-product-content" data-inspector-product-content aria-live="polite">
          ${html}
        </div>
      </section>
    `;
    root.classList.remove("is-initial-inspector-hydrating");
  };

  const renderActiveProductInspector = async (root) => {
    if (!(root instanceof HTMLElement)) return false;

    const inspectorBody = root.querySelector(INSPECTOR_BODY_SELECTOR);
    if (!(inspectorBody instanceof HTMLElement)) return false;

    if (isMapOwnedView(root)) {
      const inflight = inflightByRoot.get(root);
      if (inflight?.controller instanceof AbortController)
        inflight.controller.abort();
      inflightByRoot.delete(root);
      payloadKeyByRoot.delete(root);
      inspectorBody.setAttribute("aria-busy", "false");
      return false;
    }

    const payload = getPayload(root);
    if (!payload) {
      const inflight = inflightByRoot.get(root);
      if (inflight?.controller instanceof AbortController)
        inflight.controller.abort();
      inflightByRoot.delete(root);
      payloadKeyByRoot.delete(root);
      return false;
    }

    const payloadKey = getPayloadKey(payload);
    if (!payloadKey) return false;

    const activePanel = inspectorBody.querySelector(`.${PANEL_CLASS}`);
    if (activePanel && payloadKeyByRoot.get(root) === payloadKey) return true;

    const cache = ensureCache(root);
    if (cache.has(payloadKey)) {
      applyPanelMarkup(
        root,
        inspectorBody,
        String(cache.get(payloadKey) || ""),
        payload,
      );
      payloadKeyByRoot.set(root, payloadKey);
      return true;
    }

    const inflight = inflightByRoot.get(root);
    if (
      inflight?.payloadKey === payloadKey &&
      inflight.promise instanceof Promise
    ) {
      return inflight.promise;
    }
    if (inflight?.controller instanceof AbortController) {
      inflight.controller.abort();
      inflightByRoot.delete(root);
    }

    const inspectorUrl = buildInspectorUrl(payload);
    if (!inspectorUrl) return false;

    const requestToken =
      Number(root.dataset.commandCenterPanelRequestToken || "0") + 1;
    root.dataset.commandCenterPanelRequestToken = String(requestToken);

    const controller = new AbortController();
    inspectorBody.setAttribute("aria-busy", "true");

    const requestPromise = fetch(inspectorUrl, {
      credentials: "same-origin",
      signal: controller.signal,
    })
      .then((response) => {
        if (!response.ok)
          throw new Error(`Product panel request failed (${response.status})`);
        return response.text();
      })
      .then((html) => {
        if (
          normalizeText(root.dataset.commandCenterPanelRequestToken) !==
          String(requestToken)
        )
          return false;
        if (isMapOwnedView(root)) return false;
        const activePayload = getPayload(root);
        if (!activePayload || getPayloadKey(activePayload) !== payloadKey)
          return false;
        cache.set(payloadKey, html);
        applyPanelMarkup(root, inspectorBody, html, payload);
        payloadKeyByRoot.set(root, payloadKey);
        return true;
      })
      .catch((_error) => {
        if (controller.signal.aborted) return false;
        if (
          normalizeText(root.dataset.commandCenterPanelRequestToken) !==
          String(requestToken)
        )
          return false;
        inspectorBody.setAttribute("aria-busy", "false");
        return false;
      })
      .finally(() => {
        const current = inflightByRoot.get(root);
        if (current && current.requestToken === requestToken) {
          inflightByRoot.delete(root);
        }
      });

    inflightByRoot.set(root, {
      requestToken,
      payloadKey,
      controller,
      promise: requestPromise,
    });

    return requestPromise;
  };

  const scheduleHydration = (root) => {
    if (!(root instanceof HTMLElement)) return;

    const existingFrame = frameByRoot.get(root);
    if (typeof existingFrame === "number") {
      window.cancelAnimationFrame(existingFrame);
    }

    const frame = window.requestAnimationFrame(() => {
      frameByRoot.delete(root);
      renderActiveProductInspector(root).catch(() => {});
    });

    frameByRoot.set(root, frame);
  };

  const setJourneyTabSelection = (root, activeView) => {
    const nextView = normalizeText(activeView).toLowerCase();
    if (!nextView) return;

    const tabs = root.querySelectorAll("[data-command-center-journey-tab]");
    for (const tab of tabs) {
      if (!(tab instanceof HTMLElement)) continue;
      const tabView = normalizeText(
        tab.getAttribute("data-command-center-journey-tab"),
      ).toLowerCase();
      const isActive = tabView === nextView;
      tab.classList.toggle("is-active", isActive);
      tab.setAttribute("aria-selected", isActive ? "true" : "false");
      tab.setAttribute("tabindex", isActive ? "0" : "-1");
    }
  };

  const triggerOverviewProxyDetail = (root, detailKey) => {
    const key = normalizeText(detailKey).toLowerCase();
    if (!key) return false;
    const proxyTrigger = root.querySelector(
      `[data-command-center-overview-proxy-controls] [data-command-center-overview-detail="${key}"]`,
    );
    if (!(proxyTrigger instanceof HTMLButtonElement)) return false;
    proxyTrigger.click();
    return true;
  };

  const initializeRoot = (root) => {
    if (!(root instanceof HTMLElement)) return;
    if (root.dataset.commandCenterProductHydratorReady === "true") return;
    root.dataset.commandCenterProductHydratorReady = "true";

    const inspectorBody = root.querySelector(INSPECTOR_BODY_SELECTOR);
    if (inspectorBody instanceof HTMLElement) {
      const observer = new MutationObserver(() => {
        scheduleHydration(root);
      });
      observer.observe(inspectorBody, {
        childList: true,
        subtree: false,
        attributes: true,
        attributeFilter: ["class", "data-command-center-route-placeholder"],
      });
      observerByRoot.set(root, observer);
    }

    root.addEventListener(
      "click",
      (event) => {
        const journeyTab =
          event.target instanceof Element
            ? event.target.closest("[data-command-center-journey-tab]")
            : null;
        if (journeyTab instanceof HTMLElement) {
          const view = normalizeText(
            journeyTab.getAttribute("data-command-center-journey-tab"),
          ).toLowerCase();
          if (view === "guests") {
            triggerOverviewProxyDetail(root, "participants");
            setJourneyTabSelection(root, "guests");
          } else if (view === "pricing") {
            triggerOverviewProxyDetail(root, "pricing");
            setJourneyTabSelection(root, "pricing");
          } else if (view === "overview" || view === "route") {
            setJourneyTabSelection(root, view);
          }
        }

        scheduleHydration(root);
      },
      true,
    );

    root.addEventListener(
      "keydown",
      (event) => {
        const key = normalizeText(event?.key).toLowerCase();
        if (key === "enter" || key === " " || key === "spacebar") {
          scheduleHydration(root);
        }
      },
      true,
    );

    const intervalId = window.setInterval(() => {
      if (!document.contains(root)) {
        const observer = observerByRoot.get(root);
        if (observer) observer.disconnect();

        const inflight = inflightByRoot.get(root);
        if (inflight?.controller instanceof AbortController)
          inflight.controller.abort();

        const frame = frameByRoot.get(root);
        if (typeof frame === "number") window.cancelAnimationFrame(frame);

        window.clearInterval(intervalId);
        pollerByRoot.delete(root);
        return;
      }

      const payload = getPayload(root);
      const nextSignature = payload ? getPayloadKey(payload) : "";
      const previousSignature = signatureByRoot.get(root) || "";
      if (nextSignature !== previousSignature) {
        signatureByRoot.set(root, nextSignature);
        scheduleHydration(root);
      }
    }, 260);

    pollerByRoot.set(root, intervalId);
    scheduleHydration(root);
  };

  const initializeFromScope = (scope) => {
    if (!(scope instanceof Element) && scope !== document) return;

    const roots = [];
    if (scope instanceof Element && scope.matches(ROOT_SELECTOR))
      roots.push(scope);
    const nested = scope.querySelectorAll
      ? scope.querySelectorAll(ROOT_SELECTOR)
      : [];
    for (const root of nested) roots.push(root);

    for (const root of roots) initializeRoot(root);
  };

  ensurePanelFetchDedupe();

  const onReady = () => initializeFromScope(document);
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", onReady, { once: true });
  } else {
    onReady();
  }

  document.addEventListener("shopify:section:load", (event) => {
    const scope = event.target instanceof Element ? event.target : document;
    initializeFromScope(scope);
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wetu-itinerary-command-center-mapbox"] && !Shopify.designMode) return;
  try {
    (() => {
  const ROOT_SELECTOR = '.itin-command-center[data-section-id]';
  const INSPECTOR_BODY_SELECTOR = '[data-command-center-inspector-body]';

  const MAPBOX_GL_SCRIPT_ID = 'wetu-mapbox-gl-script';
  const MAPBOX_GL_STYLE_ID = 'wetu-mapbox-gl-style';
  const MAPBOX_GL_SCRIPT_URL = 'https://api.mapbox.com/mapbox-gl-js/v3.7.0/mapbox-gl.js';
  const MAPBOX_GL_STYLE_URL = 'https://api.mapbox.com/mapbox-gl-js/v3.7.0/mapbox-gl.css';

  const MAPBOX_LIGHT_STYLE = 'mapbox://styles/mapbox/light-v11';
  const MAPBOX_DARK_STYLE = 'mapbox://styles/mapbox/dark-v11';
  const MAP_ROUTE_COLOR_LIGHT = '#111111';
  const MAP_ROUTE_COLOR_DARK = '#ffffff';

  const MAP_SHELL_ATTR = 'data-command-center-map-shell';
  const FLIGHT_ROUTE_MODES = new Set(['charterflight', 'scheduledflight']);
  const GROUND_ROUTE_MODES = new Set(['transfer', 'selfdrive']);
  const MAP_OWNED_PAYLOAD_TYPES = new Set(['landing']);

  const mapControllers = new WeakMap();
  const mapObservers = new WeakMap();
  const journeyDataPromiseByRoot = new WeakMap();
  const itineraryPayloadByUrl = new Map();
  let mapboxResourcePromise = null;

  const normalizeText = (value) => String(value || '').replace(/\s+/g, ' ').trim();
  const prefersReducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const escapeHtml = (value) =>
    String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');

  const isObjectLike = (value) => value && typeof value === 'object';

  const unwrapValue = (value) => {
    if (isObjectLike(value) && Object.prototype.hasOwnProperty.call(value, 'value')) {
      return value.value;
    }
    return value;
  };

  const hasValue = (value) => {
    if (value === null || value === undefined) return false;
    if (typeof value === 'string') return normalizeText(value) !== '';
    return true;
  };

  const readField = (record, key) => {
    if (!isObjectLike(record)) return null;
    return unwrapValue(record[key]);
  };

  const readFirstField = (record, keys = []) => {
    for (const key of keys) {
      const nextValue = readField(record, key);
      if (hasValue(nextValue)) return nextValue;
    }
    return null;
  };

  const parseJson = (value, fallback) => {
    const source = normalizeText(value);
    if (!source) return fallback;
    try {
      return JSON.parse(source);
    } catch (error) {
      return fallback;
    }
  };

  const toNumber = (value, fallback = Number.NaN) => {
    const numeric = Number.parseFloat(String(unwrapValue(value) ?? '').replace(/[^0-9+-.]/g, ''));
    return Number.isFinite(numeric) ? numeric : fallback;
  };

  const toInteger = (value, fallback = Number.NaN) => {
    const numeric = Number.parseInt(String(unwrapValue(value) ?? ''), 10);
    return Number.isFinite(numeric) ? numeric : fallback;
  };

  const normalizeEntityId = (value) => {
    const text = normalizeText(unwrapValue(value));
    if (!text) return '';
    return /^\d+$/.test(text) ? String(Number.parseInt(text, 10)) : text.toLowerCase();
  };

  const normalizeRouteMode = (value) => normalizeText(value).replace(/\s+/g, '').toLowerCase();
  const getInspectorMode = (root, inspectorBody) => {
    if (!(root instanceof HTMLElement) || !(inspectorBody instanceof HTMLElement)) return 'details';

    const payloadType = normalizeText(root.commandCenterState?.activeInspectorPayload?.type).toLowerCase();
    const hasProductEmbed =
      inspectorBody.classList.contains('is-product-embed')
      || Boolean(inspectorBody.querySelector('.wetu-command-center-panel'));

    if (payloadType === 'product' || hasProductEmbed) {
      return 'product';
    }
    if (MAP_OWNED_PAYLOAD_TYPES.has(payloadType)) {
      return 'overview';
    }

    return 'details';
  };
  const shouldMountMapShell = (root, inspectorBody) => getInspectorMode(root, inspectorBody) === 'overview';

  const getThemeMode = (root) => {
    if (!(root instanceof HTMLElement)) return 'light';
    if (root.classList.contains('is-theme-dark') || normalizeText(root.dataset.theme).toLowerCase() === 'dark') {
      return 'dark';
    }
    return 'light';
  };

  const getMapStyleForTheme = (themeMode) => (themeMode === 'dark' ? MAPBOX_DARK_STYLE : MAPBOX_LIGHT_STYLE);
  const getRouteColorForTheme = (themeMode) => (themeMode === 'dark' ? MAP_ROUTE_COLOR_DARK : MAP_ROUTE_COLOR_LIGHT);

  const getMapSurfacePalette = (themeMode) =>
    themeMode === 'dark'
      ? { land: '#333333', water: '#2a2a2a' }
      : { land: '#f2f2f2', water: '#e8e8e8' };

  const getMapSettings = (root) => {
    if (!(root instanceof HTMLElement)) {
      return { token: '' };
    }

    const token = normalizeText(root.dataset.mapboxToken);
    return { token };
  };

  const setMapStatus = (root, message = '') => {
    const statusNode = root.querySelector('[data-command-center-journey-map-status]');
    if (!(statusNode instanceof HTMLElement)) return;

    const hasMessage = normalizeText(message) !== '';
    statusNode.hidden = !hasMessage;
    statusNode.textContent = hasMessage ? message : '';
  };

  const removeMapLayerIfPresent = (map, layerId) => {
    if (!map || !layerId || typeof map.getLayer !== 'function' || typeof map.removeLayer !== 'function') return;
    if (map.getLayer(layerId)) {
      map.removeLayer(layerId);
    }
  };

  const removeMapSourceIfPresent = (map, sourceId) => {
    if (!map || !sourceId || typeof map.getSource !== 'function' || typeof map.removeSource !== 'function') return;
    if (map.getSource(sourceId)) {
      map.removeSource(sourceId);
    }
  };

  const teardownMap = (root) => {
    const controller = mapControllers.get(root);
    if (!controller || typeof controller !== 'object') return;

    if (typeof controller.syncTimerId === 'number') {
      window.clearInterval(controller.syncTimerId);
    }

    if (typeof controller.themeSyncFrameId === 'number') {
      window.cancelAnimationFrame(controller.themeSyncFrameId);
    }

    if (controller.themeObserver && typeof controller.themeObserver.disconnect === 'function') {
      controller.themeObserver.disconnect();
    }

    if (controller.stopList && controller.stopListClickHandler) {
      controller.stopList.removeEventListener('click', controller.stopListClickHandler);
    }

    if (Array.isArray(controller.markers)) {
      controller.markers.forEach((entry) => {
        if (entry?.marker && typeof entry.marker.remove === 'function') {
          entry.marker.remove();
        }
      });
    }

    if (controller.resizeObserver && typeof controller.resizeObserver.disconnect === 'function') {
      controller.resizeObserver.disconnect();
    }

    if (controller.map && typeof controller.map.remove === 'function') {
      controller.map.remove();
    }

    mapControllers.delete(root);
  };

  const ensureMapboxGl = () => {
    if (window.mapboxgl) return Promise.resolve(window.mapboxgl);
    if (mapboxResourcePromise) return mapboxResourcePromise;

    mapboxResourcePromise = new Promise((resolve, reject) => {
      if (!document.getElementById(MAPBOX_GL_STYLE_ID)) {
        const styleTag = document.createElement('link');
        styleTag.id = MAPBOX_GL_STYLE_ID;
        styleTag.rel = 'stylesheet';
        styleTag.href = MAPBOX_GL_STYLE_URL;
        document.head.appendChild(styleTag);
      }

      const existingScript = document.getElementById(MAPBOX_GL_SCRIPT_ID);
      if (existingScript instanceof HTMLScriptElement) {
        existingScript.addEventListener(
          'load',
          () => {
            if (window.mapboxgl) {
              resolve(window.mapboxgl);
              return;
            }
            reject(new Error('Mapbox GL script loaded but mapboxgl is unavailable.'));
          },
          { once: true },
        );
        existingScript.addEventListener('error', () => reject(new Error('Failed to load Mapbox GL script.')), { once: true });
        return;
      }

      const script = document.createElement('script');
      script.id = MAPBOX_GL_SCRIPT_ID;
      script.src = MAPBOX_GL_SCRIPT_URL;
      script.async = true;
      script.onload = () => {
        if (window.mapboxgl) {
          resolve(window.mapboxgl);
          return;
        }
        reject(new Error('Mapbox GL script loaded but mapboxgl is unavailable.'));
      };
      script.onerror = () => reject(new Error('Failed to load Mapbox GL script.'));
      document.head.appendChild(script);
    }).catch((error) => {
      mapboxResourcePromise = null;
      throw error;
    });

    return mapboxResourcePromise;
  };

  const decodePolyline = (encoded) => {
    const coords = [];
    let index = 0;
    let lat = 0;
    let lng = 0;

    while (index < encoded.length) {
      let result = 0;
      let shift = 0;
      let byte;

      do {
        byte = encoded.charCodeAt(index) - 63;
        index += 1;
        result |= (byte & 0x1f) << shift;
        shift += 5;
      } while (byte >= 0x20);

      const deltaLat = result & 1 ? ~(result >> 1) : result >> 1;
      lat += deltaLat;

      result = 0;
      shift = 0;
      do {
        byte = encoded.charCodeAt(index) - 63;
        index += 1;
        result |= (byte & 0x1f) << shift;
        shift += 5;
      } while (byte >= 0x20);

      const deltaLng = result & 1 ? ~(result >> 1) : result >> 1;
      lng += deltaLng;

      coords.push([lng / 1e5, lat / 1e5]);
    }

    return coords;
  };

  const parseRoutePoints = (pointsRaw) => {
    const pointsString = normalizeText(pointsRaw);
    if (!pointsString) return [];

    try {
      if (pointsString.startsWith('{') || pointsString.includes('"f":"polyline"')) {
        const parsed = JSON.parse(pointsString);
        if (parsed && parsed.f === 'polyline' && parsed.d) {
          const decoded = decodePolyline(String(parsed.d));
          if (decoded.length >= 2) return decoded;
        }
      }
    } catch (error) {
      // Fall through to plaintext parsers.
    }

    if (pointsString.includes('|')) {
      const pipeCoords = pointsString
        .split('|')
        .map((part) => normalizeText(part))
        .filter(Boolean)
        .map((pair) => {
          const [latRaw, lngRaw] = pair.split(',');
          const lat = toNumber(latRaw);
          const lng = toNumber(lngRaw);
          if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
          return [lng, lat];
        })
        .filter((coord) => Array.isArray(coord));

      if (pipeCoords.length >= 2) return pipeCoords;
    }

    if (pointsString.includes(';')) {
      const parts = pointsString
        .split(';')
        .map((part) => normalizeText(part))
        .filter(Boolean);

      const semicolonCoords = [];
      for (let index = 0; index < parts.length - 1; index += 2) {
        const lat = toNumber(parts[index]);
        const lng = toNumber(parts[index + 1]);
        if (!Number.isFinite(lat) || !Number.isFinite(lng)) continue;
        semicolonCoords.push([lng, lat]);
      }

      if (semicolonCoords.length >= 2) return semicolonCoords;
    }

    return [];
  };

  const normalizeLongitude = (lng) => {
    let normalizedLng = lng;
    while (normalizedLng > 180) normalizedLng -= 360;
    while (normalizedLng < -180) normalizedLng += 360;
    return normalizedLng;
  };

  const createGreatCircleArc = (start, end, pointCount = 64) => {
    if (!Array.isArray(start) || !Array.isArray(end)) return [];
    if (start.length < 2 || end.length < 2) return [];

    const [startLngDeg, startLatDeg] = start;
    const [endLngDeg, endLatDeg] = end;

    if (!Number.isFinite(startLngDeg) || !Number.isFinite(startLatDeg) || !Number.isFinite(endLngDeg) || !Number.isFinite(endLatDeg)) {
      return [];
    }

    const toRad = (degrees) => (degrees * Math.PI) / 180;
    const toDeg = (radians) => (radians * 180) / Math.PI;

    const startLng = toRad(startLngDeg);
    const startLat = toRad(startLatDeg);
    const endLng = toRad(endLngDeg);
    const endLat = toRad(endLatDeg);

    const sinHalfDeltaLat = Math.sin((endLat - startLat) / 2);
    const sinHalfDeltaLng = Math.sin((endLng - startLng) / 2);
    const chord =
      sinHalfDeltaLat * sinHalfDeltaLat
      + Math.cos(startLat) * Math.cos(endLat) * sinHalfDeltaLng * sinHalfDeltaLng;
    const angularDistance = 2 * Math.atan2(Math.sqrt(chord), Math.sqrt(Math.max(0, 1 - chord)));

    if (!Number.isFinite(angularDistance) || angularDistance === 0) {
      return [
        [normalizeLongitude(startLngDeg), startLatDeg],
        [normalizeLongitude(endLngDeg), endLatDeg],
      ];
    }

    const coordinates = [];
    const pointTotal = Math.max(2, Number.parseInt(String(pointCount), 10) || 64);

    for (let index = 0; index <= pointTotal; index += 1) {
      const fraction = index / pointTotal;
      const weightStart = Math.sin((1 - fraction) * angularDistance) / Math.sin(angularDistance);
      const weightEnd = Math.sin(fraction * angularDistance) / Math.sin(angularDistance);

      const x =
        weightStart * Math.cos(startLat) * Math.cos(startLng)
        + weightEnd * Math.cos(endLat) * Math.cos(endLng);
      const y =
        weightStart * Math.cos(startLat) * Math.sin(startLng)
        + weightEnd * Math.cos(endLat) * Math.sin(endLng);
      const z = weightStart * Math.sin(startLat) + weightEnd * Math.sin(endLat);

      const lng = Math.atan2(y, x);
      const lat = Math.atan2(z, Math.sqrt(x * x + y * y));
      coordinates.push([normalizeLongitude(toDeg(lng)), toDeg(lat)]);
    }

    return coordinates;
  };

  const extractCandidateCoordinate = (candidate) => {
    const drivingLng = toNumber(candidate?.driving_longitude);
    const drivingLat = toNumber(candidate?.driving_latitude);
    if (Number.isFinite(drivingLng) && Number.isFinite(drivingLat)) {
      return { lng: drivingLng, lat: drivingLat };
    }

    const fallbackLng = toNumber(candidate?.longitude);
    const fallbackLat = toNumber(candidate?.latitude);
    if (Number.isFinite(fallbackLng) && Number.isFinite(fallbackLat)) {
      return { lng: fallbackLng, lat: fallbackLat };
    }

    return null;
  };

  const buildEntityLookup = (root) => {
    const coordsByEntityId = new Map();
    const labelByEntityId = new Map();

    const setCoordinate = (entityId, coordinate) => {
      const key = normalizeEntityId(entityId);
      if (!key || !coordinate) return;
      if (!Number.isFinite(coordinate.lng) || !Number.isFinite(coordinate.lat)) return;
      coordsByEntityId.set(key, { lng: Number(coordinate.lng), lat: Number(coordinate.lat) });
    };

    const setLabel = (entityId, label) => {
      const key = normalizeEntityId(entityId);
      const normalizedLabel = normalizeText(label);
      if (!key || !normalizedLabel) return;
      if (!labelByEntityId.has(key)) {
        labelByEntityId.set(key, normalizedLabel);
      }
    };

    const componentCandidatesRaw = parseJson(root.dataset.componentProductCandidates, []);
    const componentCandidates = Array.isArray(componentCandidatesRaw) ? componentCandidatesRaw : [];
    const candidatesByHandle = new Map();

    componentCandidates.forEach((candidate) => {
      if (!isObjectLike(candidate)) return;

      const title = normalizeText(candidate.title || candidate.handle || '');
      const coordinate = extractCandidateCoordinate(candidate);
      const candidateKeys = [
        normalizeEntityId(candidate.pin),
        normalizeEntityId(candidate.content_entity_id),
        normalizeEntityId(candidate.primary_pin),
      ].filter(Boolean);

      candidateKeys.forEach((key) => {
        if (title) setLabel(key, title);
        if (coordinate) setCoordinate(key, coordinate);
      });

      const handleKey = normalizeText(candidate.handle).toLowerCase();
      if (handleKey) {
        candidatesByHandle.set(handleKey, candidate);
      }
    });

    const pinMap = parseJson(root.dataset.pinMap, {});
    if (isObjectLike(pinMap)) {
      Object.entries(pinMap).forEach(([pin, handle]) => {
        const pinKey = normalizeEntityId(pin);
        if (!pinKey) return;

        const candidate = candidatesByHandle.get(normalizeText(handle).toLowerCase());
        if (!candidate) return;

        const title = normalizeText(candidate.title || candidate.handle || '');
        const coordinate = extractCandidateCoordinate(candidate);
        if (title) setLabel(pinKey, title);
        if (coordinate) setCoordinate(pinKey, coordinate);
      });
    }

    return {
      setCoordinate,
      setLabel,
      getCoordinate: (entityId) => coordsByEntityId.get(normalizeEntityId(entityId)) || null,
      getLabel: (entityId) => labelByEntityId.get(normalizeEntityId(entityId)) || '',
    };
  };

  const extractCanonicalPayload = (source) => {
    if (!isObjectLike(source)) return null;

    if (Array.isArray(source.legs) || Array.isArray(source.routes)) {
      return source;
    }

    const nestedKeys = ['source_json', 'sourceJson', 'itinerary', 'payload', 'data'];
    for (const key of nestedKeys) {
      const nestedValue = unwrapValue(source[key]);
      if (!isObjectLike(nestedValue)) continue;

      const extracted = extractCanonicalPayload(nestedValue);
      if (extracted) return extracted;
    }

    return source;
  };

  const fetchItineraryPayloadByUrl = async (url) => {
    const normalizedUrl = normalizeText(url);
    if (!normalizedUrl) return null;

    if (itineraryPayloadByUrl.has(normalizedUrl)) {
      return itineraryPayloadByUrl.get(normalizedUrl);
    }

    const request = fetch(normalizedUrl, { credentials: 'omit' })
      .then((response) => (response.ok ? response.json() : null))
      .catch(() => null);

    itineraryPayloadByUrl.set(normalizedUrl, request);
    const payload = await request;

    if (!payload) {
      itineraryPayloadByUrl.delete(normalizedUrl);
    }

    return payload;
  };

  const getPayloadFromExistingState = (root) => {
    const state = root?.commandCenterState;
    if (!isObjectLike(state)) return null;

    const potentialPayloads = [
      state.sourcePayload,
      state.rawPayload,
      state.canonicalPayload,
      state.itineraryPayload,
      state.payload,
      state.model,
    ];

    for (const candidate of potentialPayloads) {
      if (!isObjectLike(candidate)) continue;
      const extracted = extractCanonicalPayload(candidate);
      if (extracted && (Array.isArray(extracted.legs) || Array.isArray(extracted.routes))) {
        return extracted;
      }
    }

    return null;
  };

  const loadCanonicalPayload = async (root) => {
    const statePayload = getPayloadFromExistingState(root);
    if (statePayload) return statePayload;

    const urls = [normalizeText(root.dataset.canonicalJsonUrl), normalizeText(root.dataset.fallbackJsonUrl)].filter(Boolean);

    for (const url of urls) {
      const fetched = await fetchItineraryPayloadByUrl(url);
      const extracted = extractCanonicalPayload(fetched);
      if (extracted && (Array.isArray(extracted.legs) || Array.isArray(extracted.routes))) {
        return extracted;
      }
    }

    return null;
  };

  const inferPeriodStartDay = (leg) => {
    const periods = unwrapValue(leg?.periods);
    if (!Array.isArray(periods) || periods.length === 0) return Number.NaN;

    let minDay = Number.POSITIVE_INFINITY;
    periods.forEach((period) => {
      const rawDay = toInteger(readFirstField(period, ['itinerary_start_day', 'period_start_day']), Number.NaN);
      if (Number.isFinite(rawDay)) {
        minDay = Math.min(minDay, rawDay);
      }
    });

    if (!Number.isFinite(minDay)) return Number.NaN;
    return minDay + 1;
  };

  const inferPeriodEndDay = (leg) => {
    const periods = unwrapValue(leg?.periods);
    if (!Array.isArray(periods) || periods.length === 0) return Number.NaN;

    let maxDay = Number.NEGATIVE_INFINITY;
    periods.forEach((period) => {
      const rawDay = toInteger(readFirstField(period, ['itinerary_end_day', 'period_end_day']), Number.NaN);
      if (Number.isFinite(rawDay)) {
        maxDay = Math.max(maxDay, rawDay);
      }
    });

    if (!Number.isFinite(maxDay)) return Number.NaN;
    return maxDay + 1;
  };

  const buildRouteSegments = (payload, entityLookup) => {
    const routesRaw = Array.isArray(payload?.routes) ? payload.routes : [];

    const sortedRoutes = routesRaw
      .map((route, index) => ({ route, index }))
      .sort((left, right) => {
        const leftSequence = toInteger(readFirstField(left.route, ['sequence']), left.index);
        const rightSequence = toInteger(readFirstField(right.route, ['sequence']), right.index);
        return leftSequence - rightSequence;
      });

    const segments = [];

    sortedRoutes.forEach(({ route }, routeIndex) => {
      if (!isObjectLike(route)) return;

      const mode = normalizeText(readFirstField(route, ['mode', 'type', 'variant']) || 'Transfer');
      const normalizedMode = normalizeRouteMode(mode);
      const isFlight = FLIGHT_ROUTE_MODES.has(normalizedMode);

      const startEntityId = normalizeEntityId(readFirstField(route, ['start_content_entity_id', 'start_entity_id']));
      const endEntityId = normalizeEntityId(readFirstField(route, ['end_content_entity_id', 'end_entity_id']));

      const points = parseRoutePoints(readFirstField(route, ['points']) || '');

      let startCoordinate = entityLookup.getCoordinate(startEntityId);
      let endCoordinate = entityLookup.getCoordinate(endEntityId);

      if (!startCoordinate && points.length > 0) {
        startCoordinate = { lng: points[0][0], lat: points[0][1] };
      }

      if (!endCoordinate && points.length > 0) {
        const lastPoint = points[points.length - 1];
        endCoordinate = { lng: lastPoint[0], lat: lastPoint[1] };
      }

      if (startCoordinate && startEntityId) {
        entityLookup.setCoordinate(startEntityId, startCoordinate);
      }

      if (endCoordinate && endEntityId) {
        entityLookup.setCoordinate(endEntityId, endCoordinate);
      }

      let coordinates = [];
      if (isFlight) {
        if (startCoordinate && endCoordinate) {
          coordinates = createGreatCircleArc([startCoordinate.lng, startCoordinate.lat], [endCoordinate.lng, endCoordinate.lat], 72);
        }
      } else if (points.length >= 2) {
        coordinates = points;
      } else if (startCoordinate && endCoordinate) {
        coordinates = [
          [startCoordinate.lng, startCoordinate.lat],
          [endCoordinate.lng, endCoordinate.lat],
        ];
      }

      if (coordinates.length < 2) return;

      const defaultMode = GROUND_ROUTE_MODES.has(normalizedMode) || isFlight ? mode : 'Transfer';

      segments.push({
        id: `route-${routeIndex}`,
        mode: defaultMode,
        isFlight,
        startEntityId,
        endEntityId,
        startDay: toInteger(readFirstField(route, ['start_day']), 0),
        endDay: toInteger(readFirstField(route, ['end_day']), 0),
        coordinates,
      });
    });

    return segments;
  };

  const buildJourneyStops = (payload, entityLookup) => {
    const legsRaw = Array.isArray(payload?.legs) ? payload.legs : [];

    const sortedLegs = legsRaw
      .map((leg, index) => ({ leg, index }))
      .sort((left, right) => {
        const leftSequence = toInteger(readFirstField(left.leg, ['sequence']), left.index);
        const rightSequence = toInteger(readFirstField(right.leg, ['sequence']), right.index);
        return leftSequence - rightSequence;
      });

    let inferredDayCursor = 1;

    return sortedLegs.map(({ leg }, sortedIndex) => {
      const sequence = toInteger(readFirstField(leg, ['sequence']), sortedIndex);

      const legEntityId = normalizeEntityId(readFirstField(leg, ['content_entity_id']));
      const destinationEntityId = normalizeEntityId(readFirstField(leg, ['destination_content_entity_id']));

      const explicitStartDay = toInteger(readFirstField(leg, ['start_day', 'itinerary_start_day']), Number.NaN);
      const explicitEndDay = toInteger(readFirstField(leg, ['end_day', 'itinerary_end_day']), Number.NaN);

      const inferredPeriodStartDay = inferPeriodStartDay(leg);
      const inferredPeriodEndDay = inferPeriodEndDay(leg);

      const nightCount = Math.max(1, toInteger(readFirstField(leg, ['nights']), 1));

      const startDay =
        Number.isFinite(explicitStartDay) && explicitStartDay > 0
          ? explicitStartDay
          : Number.isFinite(inferredPeriodStartDay) && inferredPeriodStartDay > 0
            ? inferredPeriodStartDay
            : inferredDayCursor;

      const endDay =
        Number.isFinite(explicitEndDay) && explicitEndDay >= startDay
          ? explicitEndDay
          : Number.isFinite(inferredPeriodEndDay) && inferredPeriodEndDay >= startDay
            ? inferredPeriodEndDay
            : startDay + nightCount - 1;

      inferredDayCursor = Math.max(inferredDayCursor, endDay + 1);

      const legLabel = normalizeText(
        readFirstField(leg, ['accommodation_name', 'destination_name', 'name', 'title', 'label'])
          || entityLookup.getLabel(legEntityId)
          || entityLookup.getLabel(destinationEntityId)
          || `Leg ${sortedIndex + 1}`,
      );

      const coordinate = entityLookup.getCoordinate(legEntityId) || entityLookup.getCoordinate(destinationEntityId);

      return {
        index: sortedIndex,
        legIndex: sortedIndex,
        sequence,
        entityId: legEntityId || destinationEntityId,
        label: legLabel,
        dayStart: startDay,
        dayEnd: endDay,
        dayLabel: `D${Math.max(1, startDay)}`,
        lng: coordinate?.lng,
        lat: coordinate?.lat,
      };
    });
  };

  const buildJourneyData = (root, payload) => {
    const canonicalPayload = extractCanonicalPayload(payload);
    if (!canonicalPayload) return null;

    const entityLookup = buildEntityLookup(root);
    const routeSegments = buildRouteSegments(canonicalPayload, entityLookup);
    const allStops = buildJourneyStops(canonicalPayload, entityLookup);

    const resolvedStops = allStops.filter((stop) => Number.isFinite(stop.lng) && Number.isFinite(stop.lat));

    return {
      routeSegments,
      stops: resolvedStops,
      totalStops: allStops.length,
    };
  };

  const loadJourneyData = async (root) => {
    const cachedPromise = journeyDataPromiseByRoot.get(root);
    if (cachedPromise) {
      return cachedPromise;
    }

    const nextPromise = loadCanonicalPayload(root)
      .then((payload) => (payload ? buildJourneyData(root, payload) : null))
      .catch(() => null);

    journeyDataPromiseByRoot.set(root, nextPromise);

    const data = await nextPromise;
    if (!data) {
      journeyDataPromiseByRoot.delete(root);
    }

    return data;
  };

  const renderStopList = (root, stops) => {
    const stopList = root.querySelector('[data-command-center-journey-stop-list]');
    if (!(stopList instanceof HTMLOListElement)) return;

    stopList.innerHTML = stops
      .map(
        (stop, index) => `
        <li class="itin-command-center__journey-map-stop">
          <button
            type="button"
            class="itin-command-center__journey-map-stop-button${index === 0 ? ' is-active' : ''}"
            data-command-center-journey-stop-index="${index}"
            aria-label="Focus stop ${escapeHtml(stop.dayLabel)}: ${escapeHtml(stop.label)}"
          >
            <span class="itin-command-center__journey-map-stop-number">${escapeHtml(stop.dayLabel)}</span>
            <span class="itin-command-center__journey-map-stop-label">${escapeHtml(stop.label)}</span>
          </button>
        </li>
      `,
      )
      .join('');
  };

  const getActiveStopIndex = (root, maxStops) => {
    const stopCount = Number.isFinite(maxStops) ? maxStops : 0;
    if (stopCount <= 0) return 0;

    const dayKey = normalizeText(root?.commandCenterState?.activeDay);
    if (!dayKey) return 0;

    const dayToLegIndex = root?.commandCenterState?.dayToLegIndex;
    if (!dayToLegIndex || typeof dayToLegIndex !== 'object') return 0;

    const rawLegIndex = dayToLegIndex[dayKey];
    const legIndex = Number.parseInt(String(rawLegIndex ?? ''), 10);
    if (Number.isNaN(legIndex)) return 0;

    const controller = mapControllers.get(root);
    if (controller?.stopIndexByLegIndex instanceof Map) {
      const mappedStopIndex = controller.stopIndexByLegIndex.get(String(legIndex));
      if (Number.isFinite(mappedStopIndex)) {
        return Math.max(0, Math.min(mappedStopIndex, stopCount - 1));
      }

      let closestStopIndex = 0;
      let closestLegIndex = Number.NEGATIVE_INFINITY;

      controller.stopIndexByLegIndex.forEach((stopIndex, legIndexKey) => {
        const numericLegIndex = Number.parseInt(String(legIndexKey), 10);
        if (!Number.isFinite(numericLegIndex) || !Number.isFinite(stopIndex)) return;
        if (numericLegIndex <= legIndex && numericLegIndex > closestLegIndex) {
          closestLegIndex = numericLegIndex;
          closestStopIndex = stopIndex;
        }
      });

      return Math.max(0, Math.min(closestStopIndex, stopCount - 1));
    }

    return Math.max(0, Math.min(legIndex, stopCount - 1));
  };

  const updateMapProgress = (root, nextStopIndex, shouldFly = true) => {
    const controller = mapControllers.get(root);
    if (!controller || typeof controller !== 'object') return;

    const stops = Array.isArray(controller.stops) ? controller.stops : [];
    if (stops.length === 0) return;

    const boundedIndex = Math.max(0, Math.min(nextStopIndex, stops.length - 1));
    controller.selectedIndex = boundedIndex;

    const stopButtons = root.querySelectorAll('[data-command-center-journey-stop-index]');
    stopButtons.forEach((button, index) => {
      if (!(button instanceof HTMLElement)) return;
      button.classList.toggle('is-active', index === boundedIndex);
    });

    controller.markers.forEach((entry, index) => {
      if (!(entry?.element instanceof HTMLElement)) return;
      entry.element.classList.toggle('is-active', index === boundedIndex);
    });

    if (controller.map && controller.map.getSource(controller.progressSourceId)) {
      const source = controller.map.getSource(controller.progressSourceId);
      source.setData({
        type: 'Feature',
        geometry: {
          type: 'LineString',
          coordinates: stops.slice(0, boundedIndex + 1).map((stop) => [stop.lng, stop.lat]),
        },
        properties: {},
      });
    }

    if (shouldFly && controller.map) {
      controller.map.easeTo({
        center: [stops[boundedIndex].lng, stops[boundedIndex].lat],
        duration: prefersReducedMotion() ? 0 : 650,
        zoom: Math.max(controller.map.getZoom(), 4.8),
      });
    }
  };

  const ensureMapShell = (root) => {
    const inspectorBody = root.querySelector(INSPECTOR_BODY_SELECTOR);
    if (!(inspectorBody instanceof HTMLElement)) return null;
    if (!shouldMountMapShell(root, inspectorBody)) return null;

    const sectionId = normalizeText(root.dataset.sectionId || 'default').replace(/[^a-z0-9_-]/gi, '-');
    const mapCanvasId = `wetu-route-map-placeholder-${sectionId || 'default'}`;
    let shell = inspectorBody.querySelector(`[${MAP_SHELL_ATTR}]`);

    if (!(shell instanceof HTMLElement)) {
      inspectorBody.innerHTML = `
        <article class="itin-command-center__card itin-command-center__inspector-shell itin-command-center__route-placeholder-panel" ${MAP_SHELL_ATTR}>
          <div class="itin-command-center__journey-map-stage" data-command-center-journey-map-stage>
            <div
              class="itin-command-center__journey-map-canvas"
              id="${mapCanvasId}"
              data-command-center-journey-map-canvas
              role="img"
              aria-label="Journey map"
            ></div>
            <div class="itin-command-center__journey-map-fade" aria-hidden="true"></div>
            <div class="itin-command-center__journey-map-info">
              <p class="itin-command-center__journey-map-label">Journey map</p>
              <h3 class="itin-command-center__journey-map-title">Route overview</h3>
              <ol class="itin-command-center__journey-map-stop-list" data-command-center-journey-stop-list></ol>
            </div>
            <p class="itin-command-center__journey-map-status" data-command-center-journey-map-status hidden></p>
          </div>
        </article>
      `;
      inspectorBody.classList.add('is-overview-active');
      inspectorBody.setAttribute('data-command-center-route-placeholder', 'true');
      inspectorBody.setAttribute('aria-busy', 'false');
      shell = inspectorBody.querySelector(`[${MAP_SHELL_ATTR}]`);
    }

    return inspectorBody;
  };

  const setLayerPaintPropertySafely = (map, layerId, property, value) => {
    try {
      map.setPaintProperty(layerId, property, value);
    } catch (error) {
      // Ignore paint overrides that do not apply to this layer type.
    }
  };

  const applyMapSurfacePalette = (map, themeMode) => {
    if (!map || typeof map.getStyle !== 'function') return;

    const palette = getMapSurfacePalette(themeMode);
    const style = map.getStyle();
    const layers = Array.isArray(style?.layers) ? style.layers : [];

    layers.forEach((layer) => {
      if (!layer || typeof layer.id !== 'string') return;

      const layerType = normalizeText(layer.type).toLowerCase();
      const layerId = layer.id.toLowerCase();
      const sourceLayer = normalizeText(layer['source-layer']).toLowerCase();
      const identity = `${layerId} ${sourceLayer}`;

      if (layerType === 'background') {
        setLayerPaintPropertySafely(map, layer.id, 'background-color', palette.land);
        return;
      }

      if (!['fill', 'line'].includes(layerType)) return;

      const isWater = /(^|\b)water(\b|_)/.test(identity);
      const isLand = !isWater && /(land|landcover|landuse|hillshade|terrain)/.test(identity);
      if (!isWater && !isLand) return;

      const color = isWater ? palette.water : palette.land;
      if (layerType === 'fill') {
        setLayerPaintPropertySafely(map, layer.id, 'fill-color', color);
      }
      if (layerType === 'line') {
        setLayerPaintPropertySafely(map, layer.id, 'line-color', color);
      }
    });
  };

  const drawJourneyMap = (root, options = {}) => {
    const controller = mapControllers.get(root);
    if (!controller || !controller.map) return;

    const map = controller.map;
    const themeMode = getThemeMode(root);
    controller.themeMode = themeMode;

    const routeColor = getRouteColorForTheme(themeMode);
    const stops = controller.stops;

    applyMapSurfacePalette(map, themeMode);

    if (Array.isArray(controller.markers)) {
      controller.markers.forEach((entry) => {
        if (entry?.marker && typeof entry.marker.remove === 'function') {
          entry.marker.remove();
        }
      });
    }
    controller.markers = [];

    removeMapLayerIfPresent(map, controller.routeGroundLayerId);
    removeMapLayerIfPresent(map, controller.routeFlightLayerId);
    removeMapLayerIfPresent(map, controller.progressLayerId);

    removeMapSourceIfPresent(map, controller.routeGroundSourceId);
    removeMapSourceIfPresent(map, controller.routeFlightSourceId);
    removeMapSourceIfPresent(map, controller.progressSourceId);

    if (controller.groundFeatureCollection.features.length > 0) {
      map.addSource(controller.routeGroundSourceId, {
        type: 'geojson',
        data: controller.groundFeatureCollection,
      });

      map.addLayer({
        id: controller.routeGroundLayerId,
        type: 'line',
        source: controller.routeGroundSourceId,
        layout: {
          'line-join': 'round',
          'line-cap': 'round',
        },
        paint: {
          'line-color': routeColor,
          'line-width': 2,
          'line-opacity': 0.9,
        },
      });
    }

    if (controller.flightFeatureCollection.features.length > 0) {
      map.addSource(controller.routeFlightSourceId, {
        type: 'geojson',
        data: controller.flightFeatureCollection,
      });

      map.addLayer({
        id: controller.routeFlightLayerId,
        type: 'line',
        source: controller.routeFlightSourceId,
        layout: {
          'line-join': 'round',
          'line-cap': 'round',
        },
        paint: {
          'line-color': routeColor,
          'line-width': 2,
          'line-opacity': 0.88,
          'line-dasharray': [2, 2],
        },
      });
    }

    map.addSource(controller.progressSourceId, {
      type: 'geojson',
      data: {
        type: 'Feature',
        geometry: {
          type: 'LineString',
          coordinates: [[stops[0].lng, stops[0].lat]],
        },
        properties: {},
      },
    });

    map.addLayer({
      id: controller.progressLayerId,
      type: 'line',
      source: controller.progressSourceId,
      layout: {
        'line-join': 'round',
        'line-cap': 'round',
      },
      paint: {
        'line-color': routeColor,
        'line-width': 3.2,
        'line-opacity': 0.95,
      },
    });

    stops.forEach((stop, index) => {
      const markerElement = document.createElement('button');
      markerElement.type = 'button';
      markerElement.className = `itin-command-center__journey-map-marker${index === controller.selectedIndex ? ' is-active' : ''}`;
      markerElement.textContent = stop.dayLabel;
      markerElement.setAttribute('aria-label', `Focus stop ${stop.dayLabel}: ${stop.label}`);
      markerElement.addEventListener('click', (event) => {
        event.preventDefault();
        updateMapProgress(root, index, true);
      });

      const marker = new window.mapboxgl.Marker({ element: markerElement, anchor: 'center' })
        .setLngLat([stop.lng, stop.lat])
        .addTo(map);

      controller.markers.push({ marker, element: markerElement });
    });

    if (options.fitBounds) {
      const bounds = new window.mapboxgl.LngLatBounds();
      stops.forEach((stop) => {
        bounds.extend([stop.lng, stop.lat]);
      });

      controller.routeSegments.forEach((segment) => {
        const points = segment.coordinates;
        if (!Array.isArray(points) || points.length === 0) return;
        bounds.extend(points[0]);
        bounds.extend(points[points.length - 1]);
      });

      if (!bounds.isEmpty()) {
        map.fitBounds(bounds, {
          padding: { top: 80, right: 60, bottom: 140, left: 60 },
          duration: prefersReducedMotion() ? 0 : 760,
        });
      }
    }

    updateMapProgress(root, controller.selectedIndex, false);
  };

  const syncThemeWithMap = (root) => {
    const controller = mapControllers.get(root);
    if (!controller || !controller.map || !controller.isMapLoaded) return;

    if (controller.isStyleSwitching) {
      controller.pendingThemeSync = true;
      return;
    }

    const nextTheme = getThemeMode(root);
    if (nextTheme === controller.themeMode) return;

    const map = controller.map;
    const nextStyle = getMapStyleForTheme(nextTheme);

    controller.isStyleSwitching = true;
    controller.themeMode = nextTheme;

    const currentCenter = map.getCenter();
    const currentZoom = map.getZoom();
    const currentPitch = map.getPitch();
    const currentBearing = map.getBearing();

    map.setStyle(nextStyle);

    map.once('style.load', () => {
      const activeController = mapControllers.get(root);
      if (activeController !== controller) return;

      drawJourneyMap(root, { fitBounds: false });
      map.jumpTo({
        center: [currentCenter.lng, currentCenter.lat],
        zoom: currentZoom,
        pitch: currentPitch,
        bearing: currentBearing,
      });

      controller.isStyleSwitching = false;
      updateMapProgress(root, controller.selectedIndex, false);

      if (controller.pendingThemeSync) {
        controller.pendingThemeSync = false;
        syncThemeWithMap(root);
      }
    });
  };

  const observeThemeChanges = (root) => {
    const controller = mapControllers.get(root);
    if (!controller) return;

    if (controller.themeObserver && typeof controller.themeObserver.disconnect === 'function') {
      controller.themeObserver.disconnect();
    }

    const themeObserver = new MutationObserver(() => {
      if (typeof controller.themeSyncFrameId === 'number') {
        window.cancelAnimationFrame(controller.themeSyncFrameId);
      }

      controller.themeSyncFrameId = window.requestAnimationFrame(() => {
        controller.themeSyncFrameId = null;
        syncThemeWithMap(root);
      });
    });

    themeObserver.observe(root, { attributes: true, attributeFilter: ['class', 'data-theme'] });
    controller.themeObserver = themeObserver;
  };

  const mountJourneyMap = async (root) => {
    if (!(root instanceof HTMLElement)) return;

    const inspectorBodyCandidate = root.querySelector(INSPECTOR_BODY_SELECTOR);
    if (!(inspectorBodyCandidate instanceof HTMLElement)) return;
    if (!shouldMountMapShell(root, inspectorBodyCandidate)) return;

    const inspectorBody = ensureMapShell(root);
    if (!(inspectorBody instanceof HTMLElement)) return;

    const mapCanvas = inspectorBody.querySelector('[data-command-center-journey-map-canvas]');
    if (!(mapCanvas instanceof HTMLElement)) return;

    const existingController = mapControllers.get(root);
    if (existingController?.canvas === mapCanvas && existingController?.map) {
      const activeStopIndex = getActiveStopIndex(root, existingController.stops.length);
      if (activeStopIndex !== existingController.selectedIndex) {
        updateMapProgress(root, activeStopIndex, false);
      }
      syncThemeWithMap(root);
      return;
    }

    teardownMap(root);

    const settings = getMapSettings(root);

    if (!settings.token) {
      setMapStatus(root, 'Add a Mapbox public token (pk.*) in section settings to render the live map.');
      return;
    }

    const isPlaceholderToken = /your_mapbox_public_token|replace_me|example/i.test(settings.token);
    if (isPlaceholderToken) {
      setMapStatus(root, 'Add your real Mapbox token in section settings to enable the live map.');
      return;
    }

    if (!/^pk\./i.test(settings.token)) {
      setMapStatus(root, 'Use a valid Mapbox public token starting with pk.');
      return;
    }

    setMapStatus(root, 'Loading canonical journey coordinates...');
    const journeyData = await loadJourneyData(root);

    if (!journeyData) {
      setMapStatus(root, 'Canonical itinerary data could not be loaded for map rendering.');
      return;
    }

    const stops = Array.isArray(journeyData.stops) ? journeyData.stops : [];
    renderStopList(root, stops);

    if (stops.length < 2) {
      setMapStatus(root, 'At least two mapped journey stops are required in canonical itinerary data.');
      return;
    }

    let mapboxgl;
    try {
      mapboxgl = await ensureMapboxGl();
    } catch (error) {
      setMapStatus(root, 'Mapbox resources failed to load. Please refresh or verify network access.');
      return;
    }

    mapboxgl.accessToken = settings.token;

    const sectionId = normalizeText(root.dataset.sectionId || 'default').replace(/[^a-z0-9_-]/gi, '-');
    const routeGroundSourceId = `itin-route-ground-${sectionId}`;
    const routeFlightSourceId = `itin-route-flight-${sectionId}`;
    const progressSourceId = `itin-route-progress-${sectionId}`;

    const routeGroundLayerId = `itin-route-ground-layer-${sectionId}`;
    const routeFlightLayerId = `itin-route-flight-layer-${sectionId}`;
    const progressLayerId = `itin-route-progress-layer-${sectionId}`;

    const themeMode = getThemeMode(root);

    const map = new mapboxgl.Map({
      container: mapCanvas,
      style: getMapStyleForTheme(themeMode),
      center: [stops[0].lng, stops[0].lat],
      zoom: 4.3,
      pitch: 46,
      bearing: 10,
      antialias: true,
      attributionControl: false,
      cooperativeGestures: true,
    });

    const resizeTarget = inspectorBody.querySelector('[data-command-center-journey-map-stage]');
    const resizeObserver =
      'ResizeObserver' in window && resizeTarget instanceof HTMLElement
        ? new ResizeObserver(() => map.resize())
        : null;

    if (resizeObserver && resizeTarget instanceof HTMLElement) {
      resizeObserver.observe(resizeTarget);
    }

    const routeSegments = Array.isArray(journeyData.routeSegments) ? journeyData.routeSegments : [];

    const groundFeatureCollection = {
      type: 'FeatureCollection',
      features: routeSegments
        .filter((segment) => !segment.isFlight)
        .map((segment) => ({
          type: 'Feature',
          properties: {
            id: segment.id,
            mode: segment.mode,
          },
          geometry: {
            type: 'LineString',
            coordinates: segment.coordinates,
          },
        })),
    };

    const flightFeatureCollection = {
      type: 'FeatureCollection',
      features: routeSegments
        .filter((segment) => segment.isFlight)
        .map((segment) => ({
          type: 'Feature',
          properties: {
            id: segment.id,
            mode: segment.mode,
          },
          geometry: {
            type: 'LineString',
            coordinates: segment.coordinates,
          },
        })),
    };

    if (groundFeatureCollection.features.length === 0 && flightFeatureCollection.features.length === 0) {
      groundFeatureCollection.features.push({
        type: 'Feature',
        properties: {
          id: 'fallback-stops-route',
          mode: 'Transfer',
        },
        geometry: {
          type: 'LineString',
          coordinates: stops.map((stop) => [stop.lng, stop.lat]),
        },
      });
    }

    const stopIndexByLegIndex = new Map();
    stops.forEach((stop, index) => {
      stopIndexByLegIndex.set(String(stop.legIndex), index);
      if (Number.isFinite(stop.sequence)) {
        stopIndexByLegIndex.set(String(stop.sequence), index);
      }
    });

    const stopList = root.querySelector('[data-command-center-journey-stop-list]');
    const stopListClickHandler = (event) => {
      const button = event.target instanceof Element
        ? event.target.closest('[data-command-center-journey-stop-index]')
        : null;
      if (!(button instanceof HTMLButtonElement)) return;

      const stopIndex = Number.parseInt(button.dataset.commandCenterJourneyStopIndex, 10);
      if (Number.isNaN(stopIndex)) return;
      updateMapProgress(root, stopIndex, true);
    };

    if (stopList instanceof HTMLOListElement) {
      stopList.addEventListener('click', stopListClickHandler);
    }

    const controller = {
      map,
      canvas: mapCanvas,
      stops,
      routeSegments,
      stopIndexByLegIndex,
      selectedIndex: 0,
      markers: [],
      resizeObserver,
      routeGroundSourceId,
      routeFlightSourceId,
      progressSourceId,
      routeGroundLayerId,
      routeFlightLayerId,
      progressLayerId,
      groundFeatureCollection,
      flightFeatureCollection,
      stopList,
      stopListClickHandler,
      themeMode,
      themeObserver: null,
      themeSyncFrameId: null,
      isMapLoaded: false,
      isStyleSwitching: false,
      pendingThemeSync: false,
      syncTimerId: null,
    };

    mapControllers.set(root, controller);
    map.addControl(new mapboxgl.NavigationControl({ showCompass: false }), 'top-right');

    map.on('load', () => {
      const activeController = mapControllers.get(root);
      if (activeController !== controller) return;

      controller.isMapLoaded = true;
      drawJourneyMap(root, { fitBounds: true });
      observeThemeChanges(root);

      const initialStopIndex = getActiveStopIndex(root, stops.length);
      updateMapProgress(root, initialStopIndex, false);

      controller.syncTimerId = window.setInterval(() => {
        if (!document.contains(root)) {
          teardownMap(root);
          return;
        }

        const activeStopIndex = getActiveStopIndex(root, stops.length);
        if (activeStopIndex !== controller.selectedIndex) {
          updateMapProgress(root, activeStopIndex, false);
        }
      }, 700);

      setMapStatus(root, '');
    });

    map.on('error', () => {
      setMapStatus(root, 'Map rendering encountered an error. Verify the token and canonical route data.');
    });
  };

  const initRoot = (root) => {
    if (!(root instanceof HTMLElement)) return;
    if (root.getAttribute('data-command-center-mapbox-ready') === 'true') return;

    root.setAttribute('data-command-center-mapbox-ready', 'true');

    const tryMount = () => {
      void mountJourneyMap(root);
    };

    tryMount();
    window.setTimeout(tryMount, 1100);

    const inspectorBody = root.querySelector(INSPECTOR_BODY_SELECTOR);
    if (inspectorBody instanceof HTMLElement) {
      let observerFrameId = null;
      const observer = new MutationObserver(() => {
        if (typeof observerFrameId === 'number') {
          window.cancelAnimationFrame(observerFrameId);
        }

        observerFrameId = window.requestAnimationFrame(() => {
          observerFrameId = null;

          const hasMapShell = inspectorBody.querySelector(`[${MAP_SHELL_ATTR}]`);
          const inspectorMode = getInspectorMode(root, inspectorBody);

          if (inspectorMode === 'overview') {
            if (!hasMapShell) {
              tryMount();
            }
            return;
          }

          if (!hasMapShell) {
            teardownMap(root);
          }
        });
      });
      observer.observe(inspectorBody, {
        childList: true,
        subtree: false,
        attributes: true,
        attributeFilter: ['class', 'data-command-center-route-placeholder'],
      });
      mapObservers.set(root, observer);
    }
  };

  const initAll = (scope) => {
    const roots = [];
    if (scope instanceof Element && scope.matches(ROOT_SELECTOR)) {
      roots.push(scope);
    }
    scope.querySelectorAll?.(ROOT_SELECTOR).forEach((root) => roots.push(root));
    roots.forEach((root) => initRoot(root));
  };

  document.addEventListener('DOMContentLoaded', () => initAll(document));
  document.addEventListener('shopify:section:load', (event) => {
    const scope = event.target instanceof Element ? event.target : document;
    initAll(scope);
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wetu-itinerary-inspector-renderer"] && !Shopify.designMode) return;
  try {
    (() => {
  const ROOT_SELECTOR = '.itin-command-center[data-section-id]';

  const MAPBOX_GL_SCRIPT_ID = 'wetu-mapbox-gl-script';
  const MAPBOX_GL_STYLE_ID = 'wetu-mapbox-gl-style';
  const MAPBOX_GL_SCRIPT_URL = 'https://api.mapbox.com/mapbox-gl-js/v3.9.4/mapbox-gl.js';
  const MAPBOX_GL_STYLE_URL = 'https://api.mapbox.com/mapbox-gl-js/v3.9.4/mapbox-gl.css';

  const FLIGHT_EVENT_TYPES = new Set(['scheduled-flight']);
  const ROAD_EVENT_TYPES = new Set(['private-transfer', 'self-drive', 'car-hire', 'arrival-greeting']);
  const ARC_SEGMENTS = 64;

  const inspectorMapInstances = new WeakMap();
  let mapboxResourcePromise = null;
  const geocodeCache = new Map();

  const strip = (v) => String(v || '').replace(/\s+/g, ' ').trim();
  const stripHtml = (v) => String(v || '').replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
  const escAttr = (v) =>
    String(v || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  const normalizePin = (v) => {
    let nextValue = v;
    if (nextValue && typeof nextValue === 'object') {
      if (Object.prototype.hasOwnProperty.call(nextValue, 'value')) {
        nextValue = nextValue.value;
      } else if (Object.prototype.hasOwnProperty.call(nextValue, 'pin')) {
        nextValue = nextValue.pin;
      } else if (Object.prototype.hasOwnProperty.call(nextValue, 'id')) {
        nextValue = nextValue.id;
      }
    }

    const t = strip(nextValue);
    if (!t || /^\[object\s+object\]$/i.test(t)) return '';
    return /^\d+$/.test(t) ? String(Number.parseInt(t, 10)) : t.toLowerCase();
  };

  const setText = (parent, selector, text) => {
    const el = parent.querySelector(selector);
    if (el) el.textContent = strip(text);
  };

  const setHtml = (parent, selector, html) => {
    const el = parent.querySelector(selector);
    if (el) el.innerHTML = String(html || '');
  };

  const showIf = (parent, selector, condition) => {
    const el = parent.querySelector(selector);
    if (el) el.hidden = !condition;
  };

  const ensureMapboxGl = () => {
    if (window.mapboxgl) return Promise.resolve(window.mapboxgl);
    if (mapboxResourcePromise) return mapboxResourcePromise;

    mapboxResourcePromise = new Promise((resolve, reject) => {
      if (!document.getElementById(MAPBOX_GL_STYLE_ID)) {
        const link = document.createElement('link');
        link.id = MAPBOX_GL_STYLE_ID;
        link.rel = 'stylesheet';
        link.href = MAPBOX_GL_STYLE_URL;
        document.head.appendChild(link);
      }

      const existing = document.getElementById(MAPBOX_GL_SCRIPT_ID);
      if (existing instanceof HTMLScriptElement) {
        const onLoad = () => {
          window.mapboxgl ? resolve(window.mapboxgl) : reject(new Error('mapboxgl unavailable'));
        };
        existing.addEventListener('load', onLoad, { once: true });
        existing.addEventListener('error', () => reject(new Error('Mapbox script failed')), { once: true });
        return;
      }

      const script = document.createElement('script');
      script.id = MAPBOX_GL_SCRIPT_ID;
      script.src = MAPBOX_GL_SCRIPT_URL;
      script.async = true;
      script.addEventListener('load', () => {
        window.mapboxgl ? resolve(window.mapboxgl) : reject(new Error('mapboxgl unavailable'));
      }, { once: true });
      script.addEventListener('error', () => reject(new Error('Mapbox script failed')), { once: true });
      document.head.appendChild(script);
    });

    return mapboxResourcePromise;
  };

  const getCoordIndex = (root) => {
    if (!(root instanceof HTMLElement)) return new Map();
    const raw = strip(root.dataset.componentProductCandidates);
    if (!raw) return new Map();
    const index = new Map();
    try {
      const arr = JSON.parse(raw);
      if (!Array.isArray(arr)) return index;
      arr.forEach((entry) => {
        if (!entry || typeof entry !== 'object') return;
        const lng = Number.parseFloat(String(entry.driving_longitude ?? entry.longitude ?? ''));
        const lat = Number.parseFloat(String(entry.driving_latitude ?? entry.latitude ?? ''));
        if (!Number.isFinite(lng) || !Number.isFinite(lat)) return;
        [entry.pin, entry.content_entity_id, entry.primary_pin]
          .map(normalizePin)
          .filter(Boolean)
          .forEach((key) => index.set(key, { lng, lat }));
      });
    } catch (_e) {}
    return index;
  };

  const toRadians = (deg) => (deg * Math.PI) / 180;
  const toDegrees = (rad) => (rad * 180) / Math.PI;

  const greatCircleArc = (startLng, startLat, endLng, endLat, segments = ARC_SEGMENTS) => {
    const coords = [];
    const lat1 = toRadians(startLat);
    const lon1 = toRadians(startLng);
    const lat2 = toRadians(endLat);
    const lon2 = toRadians(endLng);

    const dLon = lon2 - lon1;
    const d = 2 * Math.asin(
      Math.sqrt(
        Math.sin((lat2 - lat1) / 2) ** 2 +
        Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLon / 2) ** 2
      )
    );

    if (d < 1e-10) return [[startLng, startLat], [endLng, endLat]];

    for (let i = 0; i <= segments; i++) {
      const f = i / segments;
      const a = Math.sin((1 - f) * d) / Math.sin(d);
      const b = Math.sin(f * d) / Math.sin(d);
      const x = a * Math.cos(lat1) * Math.cos(lon1) + b * Math.cos(lat2) * Math.cos(lon2);
      const y = a * Math.cos(lat1) * Math.sin(lon1) + b * Math.cos(lat2) * Math.sin(lon2);
      const z = a * Math.sin(lat1) + b * Math.sin(lat2);
      coords.push([toDegrees(Math.atan2(y, x)), toDegrees(Math.atan2(z, Math.sqrt(x * x + y * y)))]);
    }
    return coords;
  };

  const fetchDirectionsRoute = async (token, startCoord, endCoord) => {
    const url = `https://api.mapbox.com/directions/v5/mapbox/driving/${startCoord.lng},${startCoord.lat};${endCoord.lng},${endCoord.lat}?geometries=geojson&overview=full&access_token=${encodeURIComponent(token)}`;
    try {
      const resp = await fetch(url);
      if (!resp.ok) return null;
      const data = await resp.json();
      const route = data?.routes?.[0];
      if (!route?.geometry?.coordinates) return null;
      return route.geometry.coordinates;
    } catch (_e) {
      return null;
    }
  };

  const geocodePlace = async (token, query) => {
    const normalizedQuery = strip(query);
    if (!token || !normalizedQuery) return null;

    const cacheKey = `${token.slice(0, 16)}::${normalizedQuery.toLowerCase()}`;
    if (geocodeCache.has(cacheKey)) return geocodeCache.get(cacheKey);

    const request = (async () => {
      const url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(normalizedQuery)}.json?limit=1&autocomplete=false&access_token=${encodeURIComponent(token)}`;
      try {
        const resp = await fetch(url, { method: 'GET' });
        if (!resp.ok) return null;
        const data = await resp.json();
        const coords = data?.features?.[0]?.center;
        if (!Array.isArray(coords) || coords.length < 2) return null;
        const [lng, lat] = coords.map((value) => Number.parseFloat(String(value)));
        if (!Number.isFinite(lng) || !Number.isFinite(lat)) return null;
        return { lng, lat };
      } catch (_e) {
        return null;
      }
    })();

    geocodeCache.set(cacheKey, request);
    return request;
  };

  const resolveCoords = (root, payload) => {
    const index = getCoordIndex(root);
    const pins = payload.mapPins || {};
    const result = { start: null, end: null };

    const resolve = (...pinIds) => {
      for (const pinId of pinIds) {
        const key = normalizePin(pinId);
        if (key && index.has(key)) return index.get(key) || null;
      }
      return null;
    };

    result.start = resolve(pins.startPin, payload.sourceRouteStartPin, payload.startPin);
    result.end = resolve(pins.endPin, payload.sourceRouteEndPin, payload.endPin);
    if (!result.start && !result.end) {
      result.start = resolve(
        pins.primaryPin,
        payload.entityPin,
        payload.sourceContentEntityId,
        payload.pin,
        payload.sourceRouteEndPin,
        payload.sourceRouteStartPin
      );
    }
    return result;
  };

  const resolveCoordsAsync = async (root, payload) => {
    const result = resolveCoords(root, payload);
    if (result.start && result.end) return result;

    const token = strip(root?.dataset?.mapboxToken);
    if (!token || !/^pk\./i.test(token)) return result;

    const originName = strip(payload?.originName || payload?.startName || payload?.origin || '');
    const destinationName = strip(payload?.destinationName || payload?.endName || payload?.destination || '');
    const fallbackName = strip(payload?.path || payload?.mapPath || payload?.title || '');

    if (!result.start) {
      result.start = await geocodePlace(token, originName || fallbackName);
    }

    if (!result.end) {
      result.end = await geocodePlace(token, destinationName || fallbackName || originName);
    }

    return result;
  };

  const destroyInspectorMap = (container) => {
    const existing = inspectorMapInstances.get(container);
    if (existing?.map && typeof existing.map.remove === 'function') {
      existing.map.remove();
    }
    if (existing?.resizeObserver) {
      existing.resizeObserver.disconnect();
    }
    inspectorMapInstances.delete(container);
  };

  const getThemeMode = (root) => {
    if (!(root instanceof HTMLElement)) return 'light';
    if (root.classList.contains('is-theme-dark') || strip(root.dataset.theme).toLowerCase() === 'dark') {
      return 'dark';
    }
    return 'light';
  };

  const mountInspectorMap = async (root, container, payload, coords) => {
    destroyInspectorMap(container);

    const token = strip(root.dataset.mapboxToken);
    if (!token || !/^pk\./i.test(token)) return;
    if (!coords.start && !coords.end) return;

    container.style.height = '280px';

    let mapboxgl;
    try {
      mapboxgl = await ensureMapboxGl();
    } catch (_e) {
      return;
    }

    mapboxgl.accessToken = token;

    const themeMode = getThemeMode(root);
    const isFlight = FLIGHT_EVENT_TYPES.has(strip(payload.eventTypeId));
    const center = coords.start || coords.end;

    const map = new mapboxgl.Map({
      container,
      style: themeMode === 'dark' ? 'mapbox://styles/mapbox/dark-v11' : 'mapbox://styles/mapbox/light-v11',
      center: [center.lng, center.lat],
      zoom: coords.start && coords.end ? 5 : 10,
      antialias: true,
      attributionControl: false,
      cooperativeGestures: true,
    });

    const resizeObserver = 'ResizeObserver' in window
      ? new ResizeObserver(() => map.resize())
      : null;
    if (resizeObserver) resizeObserver.observe(container);

    inspectorMapInstances.set(container, { map, resizeObserver });

    map.addControl(new mapboxgl.NavigationControl({ showCompass: false }), 'top-right');

    if (coords.start) {
      new mapboxgl.Marker({ color: themeMode === 'dark' ? '#ffffff' : '#111111', scale: 0.7 })
        .setLngLat([coords.start.lng, coords.start.lat])
        .addTo(map);
    }
    if (coords.end && coords.end !== coords.start) {
      new mapboxgl.Marker({ color: themeMode === 'dark' ? '#cccccc' : '#444444', scale: 0.7 })
        .setLngLat([coords.end.lng, coords.end.lat])
        .addTo(map);
    }

    map.on('load', async () => {
      if (!coords.start || !coords.end) {
        return;
      }

      const routeColor = themeMode === 'dark' ? '#ffffff' : '#111111';
      let lineCoordinates = null;

      if (isFlight) {
        lineCoordinates = greatCircleArc(
          coords.start.lng, coords.start.lat,
          coords.end.lng, coords.end.lat
        );
      } else {
        lineCoordinates = await fetchDirectionsRoute(token, coords.start, coords.end);
        if (!lineCoordinates) {
          lineCoordinates = [
            [coords.start.lng, coords.start.lat],
            [coords.end.lng, coords.end.lat],
          ];
        }
      }

      if (lineCoordinates && lineCoordinates.length >= 2) {
        map.addSource('inspector-route', {
          type: 'geojson',
          data: {
            type: 'Feature',
            properties: {},
            geometry: { type: 'LineString', coordinates: lineCoordinates },
          },
        });

        map.addLayer({
          id: 'inspector-route-line',
          type: 'line',
          source: 'inspector-route',
          layout: { 'line-cap': 'round', 'line-join': 'round' },
          paint: {
            'line-color': routeColor,
            'line-width': isFlight ? 2 : 3,
            'line-opacity': 0.85,
            'line-dasharray': isFlight ? [3, 3] : [1],
          },
        });

        const allCoords = lineCoordinates;
        const bounds = allCoords.reduce(
          (b, c) => b.extend(c),
          new mapboxgl.LngLatBounds(allCoords[0], allCoords[0])
        );
        map.fitBounds(bounds, { padding: 48, maxZoom: 13, duration: 600 });
      }
    });
  };

  const attemptLogisticsMapMount = async (rootEl, clonedNode, payload, attempt = 0) => {
    if (!(rootEl instanceof HTMLElement) || !(clonedNode instanceof HTMLElement)) {
      return;
    }

    if (!document.contains(clonedNode)) {
      if (attempt < 12) {
        window.setTimeout(() => {
          attemptLogisticsMapMount(rootEl, clonedNode, payload, attempt + 1);
        }, 120);
      }
      return;
    }

    const mapboxContainer = clonedNode.querySelector('[data-inspector-logistics-mapbox-container]');
    const mapShell = clonedNode.querySelector('[data-inspector-logistics-map-shell]');
    if (!(mapboxContainer instanceof HTMLElement)) return;

    const coords = await resolveCoordsAsync(rootEl, payload);
    if (!document.contains(clonedNode)) {
      if (attempt < 12) {
        window.setTimeout(() => {
          attemptLogisticsMapMount(rootEl, clonedNode, payload, attempt + 1);
        }, 120);
      }
      return;
    }

    if (coords.start || coords.end) {
      if (mapShell) mapShell.hidden = false;
      mountInspectorMap(rootEl, mapboxContainer, payload, coords);
      return;
    }

    if (attempt < 12) {
      window.setTimeout(() => {
        attemptLogisticsMapMount(rootEl, clonedNode, payload, attempt + 1);
      }, 250);
      return;
    }

    if (mapShell) mapShell.hidden = true;
  };

  const renderLogisticsInspector = (clonedNode, payload, rootEl) => {
    if (!clonedNode || !payload) return;

    const t = payload;

    setText(clonedNode, '[data-inspector-logistics-mode]', t.modeLabel || t.eventTypeLabel || '');
    setText(clonedNode, '[data-inspector-logistics-title]', t.title || 'Logistics');

    const originName = strip(t.originName);
    const destinationName = strip(t.destinationName);
    const hasEndpoints = Boolean(originName || destinationName);
    showIf(clonedNode, '[data-inspector-logistics-endpoints]', hasEndpoints);
    if (hasEndpoints) {
      setText(clonedNode, '[data-inspector-logistics-origin]', originName || 'Origin');
      setText(clonedNode, '[data-inspector-logistics-destination]', destinationName || 'Destination');
    }

    const departureTime = strip(t.departureTimeRaw);
    const durationRaw = strip(t.durationRaw);
    const arrivalTime = strip(t.arrivalTimeRaw);
    const hasTiming = Boolean(departureTime || durationRaw || arrivalTime);
    showIf(clonedNode, '[data-inspector-logistics-timing]', hasTiming);
    if (hasTiming) {
      setText(clonedNode, '[data-inspector-logistics-departure]', departureTime || '--');
      setText(clonedNode, '[data-inspector-logistics-duration]', durationRaw || '--');
      setText(clonedNode, '[data-inspector-logistics-arrival]', arrivalTime || '--');
    }

    const descHtml = strip(t.descriptionHtml);
    const hasDesc = Boolean(descHtml);
    showIf(clonedNode, '[data-inspector-logistics-description]', hasDesc);
    if (hasDesc) setHtml(clonedNode, '[data-inspector-logistics-description]', descHtml);

    const dirHtml = strip(t.directionsHtml);
    const hasDir = Boolean(dirHtml);
    showIf(clonedNode, '[data-inspector-logistics-directions]', hasDir);
    if (hasDir) setHtml(clonedNode, '[data-inspector-logistics-directions]', dirHtml);

    const contactName = strip(t.contactNameRaw);
    const contactPhone = strip(t.contactPhoneRaw);
    const contactEmail = strip(t.contactEmailRaw);
    const hasContact = Boolean(contactName || contactPhone || contactEmail);

    const meeting = strip(t.meetingInstructionsRaw);
    const hasMeeting = Boolean(meeting);
    const reference = strip(t.referenceCodeRaw);
    const hasReference = Boolean(reference);
    const flightCode = strip(t.flightCodeRaw);
    const terminal = strip(t.terminalRaw);
    const hasFlight = Boolean(flightCode);

    const hasAnySectionBelow = hasContact || hasMeeting || hasReference || hasFlight;
    showIf(clonedNode, '[data-inspector-logistics-separator]', hasAnySectionBelow && (hasDesc || hasDir || hasTiming));

    showIf(clonedNode, '[data-inspector-logistics-contact-section]', hasContact);
    if (hasContact) {
      setText(clonedNode, '[data-inspector-logistics-contact-name]', contactName);

      const phoneEl = clonedNode.querySelector('[data-inspector-logistics-contact-phone]');
      if (phoneEl) {
        if (contactPhone) {
          phoneEl.href = `tel:${contactPhone.replace(/\s+/g, '')}`;
          phoneEl.textContent = contactPhone;
          phoneEl.hidden = false;
        } else {
          phoneEl.hidden = true;
        }
      }

      const emailEl = clonedNode.querySelector('[data-inspector-logistics-contact-email]');
      if (emailEl) {
        if (contactEmail) {
          emailEl.href = `mailto:${contactEmail}`;
          emailEl.textContent = contactEmail;
          emailEl.hidden = false;
        } else {
          emailEl.hidden = true;
        }
      }
    }

    showIf(clonedNode, '[data-inspector-logistics-meeting-section]', hasMeeting);
    if (hasMeeting) setText(clonedNode, '[data-inspector-logistics-meeting]', meeting);

    showIf(clonedNode, '[data-inspector-logistics-reference-section]', hasReference);
    if (hasReference) setText(clonedNode, '[data-inspector-logistics-reference]', reference);

    showIf(clonedNode, '[data-inspector-logistics-flight-section]', hasFlight);
    if (hasFlight) {
      setText(clonedNode, '[data-inspector-logistics-flight-code]', flightCode);
      const termEl = clonedNode.querySelector('[data-inspector-logistics-terminal]');
      if (termEl) {
        if (terminal) {
          termEl.textContent = terminal;
          termEl.hidden = false;
        } else {
          termEl.hidden = true;
        }
      }
    }

    const mapsLink = clonedNode.querySelector('[data-inspector-logistics-maps-link]');
    if (mapsLink) {
      if (originName && destinationName) {
        const gmUrl = `https://www.google.com/maps/dir/?api=1&origin=${encodeURIComponent(originName)}&destination=${encodeURIComponent(destinationName)}&travelmode=driving`;
        mapsLink.href = gmUrl;
        mapsLink.hidden = false;
      } else {
        mapsLink.hidden = true;
      }
    }

    const mapboxContainer = clonedNode.querySelector('[data-inspector-logistics-mapbox-container]');
    if (mapboxContainer && rootEl) {
      attemptLogisticsMapMount(rootEl, clonedNode, t);
    }
  };

  const renderGuestsInspector = (clonedNode, payload, _rootEl) => {
    if (!clonedNode || !payload) return;

    const t = payload;
    setText(clonedNode, '[data-inspector-guests-mode]', t.modeLabel || 'Guest list');
    setText(clonedNode, '[data-inspector-guests-title]', t.title || 'Your Travel Party');

    const metaEl = clonedNode.querySelector('[data-inspector-guests-meta]');
    if (metaEl) {
      const value = strip(t.meta);
      metaEl.textContent = value;
      metaEl.hidden = !value;
    }

    const summaryEl = clonedNode.querySelector('[data-inspector-guests-summary]');
    if (summaryEl) {
      const value = strip(t.summary);
      summaryEl.textContent = value;
      summaryEl.hidden = !value;
    }

    const groupsHost = clonedNode.querySelector('[data-inspector-guests-groups]');
    const emptyEl = clonedNode.querySelector('[data-inspector-guests-empty]');
    if (!groupsHost) return;

    const toBool = (value) => {
      if (value === true) return true;
      if (typeof value === 'number') return value > 0;
      const normalized = strip(value).toLowerCase();
      return ['1', 'true', 'yes', 'y', 'lead', 'primary'].includes(normalized);
    };

    const normalizeCategory = (value) => {
      const text = strip(value).toLowerCase();
      if (/(infant|baby|toddler)/.test(text)) return 'infant';
      if (/(child|children|kid|teen|minor|youth)/.test(text)) return 'child';
      return 'adult';
    };

    const collectTags = (entry) => {
      const tags = [];
      const seen = new Set();

      const ingest = (value) => {
        if (Array.isArray(value)) {
          value.forEach((item) => ingest(item));
          return;
        }
        const text = strip(value);
        if (!text) return;
        const parts = text.includes(',') ? text.split(',') : [text];
        parts.forEach((part) => {
          const normalized = strip(part);
          if (!normalized) return;
          const key = normalized.toLowerCase();
          if (seen.has(key)) return;
          seen.add(key);
          tags.push(normalized);
        });
      };

      ingest(entry?.interests);
      ingest(entry?.preferences);
      ingest(entry?.specialInterests);
      ingest(entry?.special_interests);
      return tags.slice(0, 8);
    };

    const rawTravellers = Array.isArray(t.travellers)
      ? t.travellers
      : Array.isArray(t.travelers)
        ? t.travelers
        : Array.isArray(t.profiles)
          ? t.profiles
          : [];

    const travellers = rawTravellers
      .map((entry, index) => {
        if (!entry || typeof entry !== 'object') return null;
        const displayName = strip(
          entry.displayName || entry.knownAs || entry.firstName || entry.name || entry.fullName
        );
        if (!displayName) return null;
        const roleText = strip(entry.role || entry.relationship || entry.relationship_to_lead);
        const interestsSummary = strip(entry.interestsSummary || '');
        const dietarySummary = strip(entry.dietarySummary || '');
        const accommodationsMade = Array.isArray(entry.accommodationsMade)
          ? entry.accommodationsMade.map((a) => strip(a)).filter(Boolean)
          : [];
        return {
          name: displayName,
          role: roleText,
          category: normalizeCategory(
            entry.ageCategory || entry.age_category || entry.type || entry.traveller_type || entry.traveler_type
          ),
          interests: collectTags(entry),
          interestsSummary,
          dietarySummary,
          accommodationsMade,
          isLead:
            toBool(entry.isLead) ||
            toBool(entry.isPrimary) ||
            toBool(entry.primaryContact) ||
            toBool(entry.isPrimaryContact) ||
            toBool(entry.leadTraveller) ||
            toBool(entry.leadTraveler) ||
            /\b(lead|primary|main)\b/i.test(roleText),
          sourceIndex: index,
        };
      })
      .filter(Boolean);

    if (travellers.length === 0) {
      groupsHost.innerHTML = '';
      if (emptyEl) emptyEl.hidden = false;
      return;
    }

    const groups = {
      adult: { label: 'The Party', travellers: [] },
      child: { label: 'Young Explorers', travellers: [] },
      infant: { label: 'Little Ones', travellers: [] },
    };

    travellers.forEach((traveller) => {
      const key = traveller.category in groups ? traveller.category : 'adult';
      groups[key].travellers.push(traveller);
    });

    Object.keys(groups).forEach((key) => {
      groups[key].travellers.sort((a, b) => {
        if (a.isLead === b.isLead) return a.sourceIndex - b.sourceIndex;
        return a.isLead ? -1 : 1;
      });
    });

    const orderedKeys = ['adult', 'child', 'infant'].filter(
      (key) => groups[key].travellers.length > 0
    );
    const showGroupTitles = orderedKeys.length > 1;

    groupsHost.innerHTML = orderedKeys
      .map((key) => {
        const group = groups[key];
        const listHtml = group.travellers
          .map((traveller) => {
            const interests = traveller.interestsSummary || traveller.interests.join(', ');
            const roleLabel = traveller.role && !traveller.isLead ? traveller.role : '';
            const accommodationsHtml = traveller.accommodationsMade.length > 0
              ? `<ul class="itin-command-center__guest-detail-accommodations">
                  ${traveller.accommodationsMade.map((a) => `<li>${escAttr(a)}</li>`).join('')}
                </ul>`
              : '';
            return `<li class="itin-command-center__guest-detail-item${traveller.isLead ? ' is-lead' : ''}">
              <div class="itin-command-center__guest-detail-name-row">
                <p class="itin-command-center__guest-detail-name">${escAttr(traveller.name)}</p>
                ${traveller.isLead ? '<p class="itin-command-center__guest-detail-lead">Lead traveller</p>' : ''}
                ${roleLabel ? `<p class="itin-command-center__guest-detail-role">${escAttr(roleLabel)}</p>` : ''}
              </div>
              ${interests ? `<p class="itin-command-center__guest-detail-interests">Interests: ${escAttr(interests)}</p>` : ''}
              ${traveller.dietarySummary ? `<p class="itin-command-center__guest-detail-dietary">Dietary: ${escAttr(traveller.dietarySummary)}</p>` : ''}
              ${accommodationsHtml ? `<div class="itin-command-center__guest-detail-accommodations-block"><p class="itin-command-center__guest-detail-accommodations-label">Accommodations made:</p>${accommodationsHtml}</div>` : ''}
            </li>`;
          })
          .join('');

        return `<section class="itin-command-center__guest-detail-group">
          ${showGroupTitles ? `<p class="itin-command-center__guest-detail-group-title">${escAttr(group.label)}</p>` : ''}
          <ul class="itin-command-center__guest-detail-list">${listHtml}</ul>
        </section>`;
      })
      .join('');

    const pdp = t.preDeparturePack;
    if (pdp && typeof pdp === 'object') {
      let preDepartureHtml = '<details class="itin-command-center__pre-departure-pack"><summary class="itin-command-center__pre-departure-summary">Pre-Departure Information</summary><div class="itin-command-center__pre-departure-content">';

      if (pdp.packingAdvisory) {
        const pa = pdp.packingAdvisory;
        preDepartureHtml += '<section class="itin-command-center__pre-departure-section">';
        preDepartureHtml += '<h4 class="itin-command-center__pre-departure-title">Packing Advisory</h4>';
        if (pa.climateSummary) {
          preDepartureHtml += `<p class="itin-command-center__pre-departure-climate">${escAttr(pa.climateSummary)}</p>`;
        }
        if (pa.essentialItems && pa.essentialItems.length > 0) {
          preDepartureHtml += '<p class="itin-command-center__pre-departure-label">Essential items:</p><ul class="itin-command-center__pre-departure-list">';
          pa.essentialItems.forEach((item) => { preDepartureHtml += `<li>${escAttr(item)}</li>`; });
          preDepartureHtml += '</ul>';
        }
        if (pa.recommendedItems && pa.recommendedItems.length > 0) {
          preDepartureHtml += '<p class="itin-command-center__pre-departure-label">Recommended items:</p><ul class="itin-command-center__pre-departure-list">';
          pa.recommendedItems.forEach((item) => { preDepartureHtml += `<li>${escAttr(item)}</li>`; });
          preDepartureHtml += '</ul>';
        }
        if (pa.dressCodeNotes) {
          preDepartureHtml += `<p class="itin-command-center__pre-departure-note">${escAttr(pa.dressCodeNotes)}</p>`;
        }
        preDepartureHtml += '</section>';
      }

      if (pdp.tippingGuidelines) {
        const tg = pdp.tippingGuidelines;
        preDepartureHtml += '<section class="itin-command-center__pre-departure-section">';
        preDepartureHtml += '<h4 class="itin-command-center__pre-departure-title">Tipping Guidelines</h4>';
        if (tg.currencyRecommendations) {
          preDepartureHtml += `<p class="itin-command-center__pre-departure-currency">${escAttr(tg.currencyRecommendations)}</p>`;
        }
        if (tg.generalGuidance) {
          preDepartureHtml += `<p class="itin-command-center__pre-departure-guidance">${escAttr(tg.generalGuidance)}</p>`;
        }
        if (tg.suggestedAmounts && tg.suggestedAmounts.length > 0) {
          preDepartureHtml += '<ul class="itin-command-center__pre-departure-amounts">';
          tg.suggestedAmounts.forEach((sa) => {
            preDepartureHtml += `<li><span class="itin-command-center__pre-departure-amount-context">${escAttr(sa.context)}:</span> ${escAttr(sa.amount)}</li>`;
          });
          preDepartureHtml += '</ul>';
        }
        preDepartureHtml += '</section>';
      }

      if (pdp.healthBriefing) {
        const hb = pdp.healthBriefing;
        preDepartureHtml += '<section class="itin-command-center__pre-departure-section">';
        preDepartureHtml += '<h4 class="itin-command-center__pre-departure-title">Health Briefing</h4>';
        if (hb.vaccinationRecommendations && hb.vaccinationRecommendations.length > 0) {
          preDepartureHtml += '<p class="itin-command-center__pre-departure-label">Vaccination recommendations:</p><ul class="itin-command-center__pre-departure-list">';
          hb.vaccinationRecommendations.forEach((v) => { preDepartureHtml += `<li>${escAttr(v)}</li>`; });
          preDepartureHtml += '</ul>';
        }
        if (hb.malariaAdvisory) {
          preDepartureHtml += `<p class="itin-command-center__pre-departure-malaria"><strong>Malaria:</strong> ${escAttr(hb.malariaAdvisory)}</p>`;
        }
        if (hb.generalHealthTips && hb.generalHealthTips.length > 0) {
          preDepartureHtml += '<p class="itin-command-center__pre-departure-label">Health tips:</p><ul class="itin-command-center__pre-departure-list">';
          hb.generalHealthTips.forEach((tip) => { preDepartureHtml += `<li>${escAttr(tip)}</li>`; });
          preDepartureHtml += '</ul>';
        }
        preDepartureHtml += '</section>';
      }

      if (pdp.emergencyContacts && pdp.emergencyContacts.length > 0) {
        preDepartureHtml += '<section class="itin-command-center__pre-departure-section">';
        preDepartureHtml += '<h4 class="itin-command-center__pre-departure-title">Emergency Contacts</h4>';
        preDepartureHtml += '<ul class="itin-command-center__pre-departure-contacts">';
        pdp.emergencyContacts.forEach((ec) => {
          const contactLine = [ec.name, ec.phone].filter(Boolean).join(': ');
          preDepartureHtml += `<li><strong>${escAttr(ec.type || 'Contact')}:</strong> ${escAttr(contactLine)}${ec.notes ? ` (${escAttr(ec.notes)})` : ''}</li>`;
        });
        preDepartureHtml += '</ul>';
        preDepartureHtml += '</section>';
      }

      if (pdp.visaSummary) {
        preDepartureHtml += '<section class="itin-command-center__pre-departure-section">';
        preDepartureHtml += '<h4 class="itin-command-center__pre-departure-title">Visa Information</h4>';
        preDepartureHtml += `<p class="itin-command-center__pre-departure-visa">${escAttr(pdp.visaSummary)}</p>`;
        preDepartureHtml += '</section>';
      }

      preDepartureHtml += '</div></details>';
      groupsHost.innerHTML += preDepartureHtml;
    }

    if (emptyEl) emptyEl.hidden = true;
  };

  const renderPricingInspector = (clonedNode, payload, rootEl) => {
    if (!clonedNode || !payload) return;

    const currencyCode = (() => {
      if (rootEl instanceof HTMLElement) {
        const c = strip(rootEl.dataset.currencyCode);
        if (c) return c;
      }
      return strip(payload.currency) || 'USD';
    })();

    const fmtCurrency = (value) => {
      const n = Number.isFinite(value) ? value : 0;
      if (n === 0) return '—';
      try {
        return new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: currencyCode,
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        }).format(n);
      } catch (_e) {
        return `${currencyCode} ${Math.round(n)}`;
      }
    };

    const toNum = (v, fallback = 0) => {
      if (typeof v === 'number' && Number.isFinite(v)) return v;
      const n = Number.parseFloat(String(v ?? '').replace(/[^0-9.-]/g, ''));
      return Number.isFinite(n) ? n : fallback;
    };

    const t = payload;

    setText(clonedNode, '[data-inspector-pricing-mode]', t.modeLabel || 'Pricing breakdown');
    setText(clonedNode, '[data-inspector-pricing-title]', t.title || 'Pricing & Inclusions');

    const totalInvestment = toNum(t.totalInvestment);
    const perPerson = toNum(t.perPerson);
    const partySize = toNum(t.partySize, 1);

    setText(clonedNode, '[data-inspector-pricing-per-person]',
      perPerson > 0 ? fmtCurrency(perPerson) : (totalInvestment > 0 ? fmtCurrency(totalInvestment) : '—'));
    setText(clonedNode, '[data-inspector-pricing-total]',
      totalInvestment > 0 ? fmtCurrency(totalInvestment) : '—');

    const partyNote = clonedNode.querySelector('[data-inspector-pricing-party-note]');
    if (partyNote) {
      if (partySize > 1 && totalInvestment > 0) {
        partyNote.textContent = `Based on ${partySize} guest${partySize !== 1 ? 's' : ''}`;
        partyNote.hidden = false;
      } else {
        partyNote.hidden = true;
      }
    }

    const adultAvg = toNum(t.adultAverage);
    const childAvg = toNum(t.childAverage);
    const logisticsTotal = toNum(t.logisticsTotal);
    const hasMetrics = adultAvg > 0 || childAvg > 0 || logisticsTotal > 0;
    const metricsWrap = clonedNode.querySelector('[data-inspector-pricing-summary-metrics]');
    if (metricsWrap) {
      metricsWrap.hidden = !hasMetrics;
      const adultEl = metricsWrap.querySelector('[data-inspector-pricing-metric-adult]');
      if (adultEl) { adultEl.textContent = `Adult average: ${fmtCurrency(adultAvg)}`; adultEl.hidden = adultAvg <= 0; }
      const childEl = metricsWrap.querySelector('[data-inspector-pricing-metric-child]');
      if (childEl) { childEl.textContent = `Child average: ${fmtCurrency(childAvg)}`; childEl.hidden = childAvg <= 0; }
      const logEl = metricsWrap.querySelector('[data-inspector-pricing-metric-logistics]');
      if (logEl) { logEl.textContent = `Fixed logistics: ${fmtCurrency(logisticsTotal)}`; logEl.hidden = logisticsTotal <= 0; }
    }

    let rawPhases = Array.isArray(t.phases) ? t.phases : [];
    if (rawPhases.length === 0 && Array.isArray(t.priceComponents)) {
      rawPhases = t.priceComponents.map(pc => ({
        name: pc.component_name || pc.name || 'Phase',
        dateRange: pc.days || pc.date_range || '',
        total: pc.phase_total ?? pc.total ?? null,
        lineItems: (Array.isArray(pc.sub_items) ? pc.sub_items : Array.isArray(pc.line_items) ? pc.line_items : []).map(si => ({
          description: si.label || si.description || 'Item',
          quantity: si.quantity || 0,
          unitPrice: si.unit_cost ?? si.unit_price ?? null,
          total: si.total ?? si.line_total ?? null,
        })),
      }));
    }
    const phases = rawPhases;
    const hasPhases = phases.length > 0;
    showIf(clonedNode, '[data-inspector-pricing-phases-separator]', hasPhases);
    showIf(clonedNode, '[data-inspector-pricing-phases]', hasPhases);
    if (hasPhases) {
      const list = clonedNode.querySelector('[data-inspector-pricing-phases-list]');
      if (list) {
        list.innerHTML = phases.map((phase) => {
          const name = escAttr(strip(phase.name || phase.label || 'Phase'));
          const dateRange = escAttr(strip(phase.dateRange || ''));
          const phaseTotal = toNum(phase.total, Number.NaN);
          const phaseTotalStr = Number.isFinite(phaseTotal) ? escAttr(fmtCurrency(phaseTotal)) : '';
          const items = Array.isArray(phase.lineItems) ? phase.lineItems : [];
          const itemsHtml = items.map((item) => {
            const desc = escAttr(strip(item.description || item.label || item.name || 'Item'));
            const qty = toNum(item.quantity, 0);
            const unitPrice = toNum(item.unitPrice || item.unit_price, Number.NaN);
            const lineTotal = toNum(item.total || item.lineTotal || item.line_total, Number.NaN);
            const lineTotalStr = Number.isFinite(lineTotal) ? escAttr(fmtCurrency(lineTotal)) : '';
            const metaParts = [];
            if (qty > 0) metaParts.push(`Qty: ${qty}`);
            if (Number.isFinite(unitPrice)) metaParts.push(`Unit: ${fmtCurrency(unitPrice)}`);
            const metaStr = metaParts.length > 0 ? escAttr(metaParts.join(' · ')) : '';
            return `<div class="itin-command-center__pricing-detail-line-item">
              <span class="itin-command-center__pricing-detail-line-desc">${desc}</span>
              ${lineTotalStr ? `<span class="itin-command-center__pricing-detail-line-total">${lineTotalStr}</span>` : ''}
              ${metaStr ? `<span class="itin-command-center__pricing-detail-line-meta">${metaStr}</span>` : ''}
            </div>`;
          }).join('');
          return `<details class="itin-command-center__pricing-detail-phase">
            <summary>
              <span>
                <span class="itin-command-center__pricing-detail-phase-name">${name}</span>
                ${dateRange ? `<span class="itin-command-center__pricing-detail-phase-dates">${dateRange}</span>` : ''}
              </span>
              ${phaseTotalStr ? `<span class="itin-command-center__pricing-detail-phase-total">${phaseTotalStr}</span>` : ''}
            </summary>
            ${items.length > 0 ? `<div class="itin-command-center__pricing-detail-phase-items">${itemsHtml}</div>` : ''}
          </details>`;
        }).join('');
      }
    }

    const includes = Array.isArray(t.includes) ? t.includes : [];
    const excludes = Array.isArray(t.excludes) ? t.excludes : [];
    const hasInclExcl = includes.length > 0 || excludes.length > 0;
    showIf(clonedNode, '[data-inspector-pricing-inclusions-separator]', hasInclExcl && (hasPhases || hasMetrics));
    showIf(clonedNode, '[data-inspector-pricing-inclusions-section]', includes.length > 0);
    if (includes.length > 0) {
      const ul = clonedNode.querySelector('[data-inspector-pricing-includes-list]');
      if (ul) ul.innerHTML = includes.map((item) => `<li>${escAttr(strip(item))}</li>`).join('');
    }
    showIf(clonedNode, '[data-inspector-pricing-exclusions-section]', excludes.length > 0);
    if (excludes.length > 0) {
      const ul = clonedNode.querySelector('[data-inspector-pricing-excludes-list]');
      if (ul) ul.innerHTML = excludes.map((item) => `<li>${escAttr(strip(item))}</li>`).join('');
    }

    const milestones = Array.isArray(t.paymentSchedule) ? t.paymentSchedule : [];
    const hasMilestones = milestones.length > 0;
    showIf(clonedNode, '[data-inspector-pricing-schedule-separator]', hasMilestones);
    showIf(clonedNode, '[data-inspector-pricing-schedule]', hasMilestones);
    if (hasMilestones) {
      const schedList = clonedNode.querySelector('[data-inspector-pricing-schedule-list]');
      if (schedList) {
        schedList.innerHTML = milestones.map((ms) => {
          const label = escAttr(strip(ms.label || ms.name || ms.milestone || 'Payment'));
          const amount = toNum(ms.amount, Number.NaN);
          const amountStr = Number.isFinite(amount) ? escAttr(fmtCurrency(amount)) : '';
          const dueDate = escAttr(strip(ms.dueDate || ms.due_date || ''));
          const pct = toNum(ms.percentage, Number.NaN);
          const status = escAttr(strip(ms.status || ''));
          const metaParts = [];
          if (dueDate) metaParts.push(`Due: ${dueDate}`);
          if (Number.isFinite(pct)) metaParts.push(`${pct}%`);
          const metaStr = metaParts.length > 0 ? escAttr(metaParts.join(' · ')) : '';
          return `<div class="itin-command-center__pricing-detail-milestone">
            <span class="itin-command-center__pricing-detail-milestone-label">${label}</span>
            ${amountStr ? `<span class="itin-command-center__pricing-detail-milestone-amount">${amountStr}</span>` : ''}
            ${metaStr ? `<span class="itin-command-center__pricing-detail-milestone-meta">${metaStr}</span>` : ''}
            ${status ? `<span class="itin-command-center__pricing-detail-milestone-status">${status}</span>` : ''}
          </div>`;
        }).join('');
      }
    }

    if (rootEl) {
      renderInlineBookingPrompt(clonedNode, rootEl);
    }
  };

  const renderInlineBookingPrompt = (container, rootEl) => {
    if (!container || !(rootEl instanceof HTMLElement)) return;

    const variantId = strip(rootEl.dataset.productSelectedVariantId);
    if (!variantId) return;

    const currencyCode = strip(rootEl.dataset.currencyCode) || 'USD';
    const localeCode = strip(rootEl.dataset.localeCode) || 'en';

    const fmtPrice = (cents) => {
      const n = (Number.isFinite(cents) ? cents : 0) / 100;
      if (n === 0) return '';
      try {
        return new Intl.NumberFormat(localeCode, {
          style: 'currency',
          currency: currencyCode,
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(n);
      } catch (_e) {
        return `${currencyCode} ${n.toFixed(2)}`;
      }
    };

    const productId = strip(rootEl.dataset.productId);
    const productUrl = productId
      ? `/products/${strip(rootEl.dataset.productHandle)}.js`
      : '';

    const wrapper = document.createElement('section');
    wrapper.className = 'itin-command-center__inline-booking-prompt';
    wrapper.setAttribute('data-inline-booking-prompt', '');

    const priceLabel = document.createElement('p');
    priceLabel.className = 'itin-command-center__inline-booking-price';
    priceLabel.setAttribute('data-inline-booking-price', '');
    priceLabel.textContent = 'Loading price\u2026';

    const cta = document.createElement('button');
    cta.type = 'button';
    cta.className = 'itin-command-center__booking-cta';
    cta.setAttribute('data-inline-booking-cta', '');
    cta.setAttribute('aria-disabled', 'true');
    cta.textContent = 'Pay now via Shopify checkout';

    const status = document.createElement('p');
    status.className = 'itin-command-center__booking-status';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    status.hidden = true;

    wrapper.appendChild(priceLabel);
    wrapper.appendChild(cta);
    wrapper.appendChild(status);
    container.appendChild(wrapper);

    (async () => {
      try {
        const resp = await fetch(productUrl);
        if (!resp.ok) throw new Error('Could not load product');
        const product = await resp.json();
        const variants = Array.isArray(product.variants) ? product.variants : [];
        const variant = variants.find((v) => String(v.id) === variantId) ||
          variants.find((v) => v.available) || variants[0];
        if (!variant) {
          priceLabel.textContent = 'Pricing unavailable';
          return;
        }
        const price = Number(variant.price);
        const formatted = fmtPrice(price);
        priceLabel.textContent = formatted ? `From ${formatted} per person` : 'Pricing unavailable';
        if (formatted && variant.available !== false) {
          cta.setAttribute('aria-disabled', 'false');
          cta.addEventListener('click', async () => {
            if ('true' === cta.getAttribute('aria-disabled')) return;
            cta.textContent = 'Adding\u2026';
            cta.setAttribute('aria-disabled', 'true');
            try {
              const addResp = await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ id: variant.id, quantity: 1 }),
              });
              if (!addResp.ok) {
                const errData = await addResp.json().catch(() => ({}));
                throw new Error(errData.description || errData.message || 'Could not add to cart');
              }
              window.location.href = '/checkout';
            } catch (err) {
              status.textContent = String(err?.message || 'Something went wrong. Please try again.');
              status.hidden = false;
              cta.textContent = 'Pay now via Shopify checkout';
              cta.setAttribute('aria-disabled', 'false');
            }
          });
        }
      } catch (_e) {
        priceLabel.textContent = 'Pricing unavailable';
      }
    })();
  };

  const wireBookingCta = (bookingEl, state, setStatus, setControlsDisabled, toInt) => {
    const cta = bookingEl.querySelector('[data-inspector-booking-cta]');
    if (!cta) return;
    cta.addEventListener('click', async (ev) => {
      if ('true' === String(bookingEl.dataset.bookingCanonicalOnly || '').trim()) {
        return;
      }
      if ('true' === cta.getAttribute('aria-disabled')) return ev.preventDefault();
      ev.preventDefault();
      const vid = strip(state.variantId);
      const qty = Math.max(1, toInt(state.guests, 1));
      if (!vid) return void setStatus(bookingEl, 'No variant selected.');
      cta.textContent = 'Adding\u2026';
      cta.setAttribute('aria-disabled', 'true');
      setControlsDisabled(bookingEl, true);
      try {
        const resp = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: Number(vid), quantity: qty }),
        });
        if (!resp.ok) {
          const errData = await resp.json().catch(() => ({}));
          throw new Error(errData.description || errData.message || 'Could not add to cart');
        }
        window.location.href = '/checkout';
      } catch (err) {
        setStatus(bookingEl, String(err?.message || 'Something went wrong. Please try again.'));
        cta.textContent = 'Pay now via Shopify checkout';
        cta.setAttribute('aria-disabled', 'false');
        setControlsDisabled(bookingEl, false);
      }
    });
  };

  window.__plekifyInspectorRenderer = {
    renderLogistics: renderLogisticsInspector,
    renderGuests: renderGuestsInspector,
    renderPricing: renderPricingInspector,
    renderInlineBooking: renderInlineBookingPrompt,
    wireBookingCta: wireBookingCta,
  };
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wetu-itinerary-operations-script"] && !Shopify.designMode) return;
  try {
    (() => {
  const ROOT_SELECTOR = '.itin-ops[data-section-id]';

  // ══════════════════════════════════════════════════════════════════════════
  // UTILITY FUNCTIONS
  // ══════════════════════════════════════════════════════════════════════════

  const hasOwn = (obj, key) => Object.prototype.hasOwnProperty.call(obj, key);
  const text = (value) => String(value ?? '').replace(/\s+/g, ' ').trim();

  const escapeHtml = (value) =>
    String(value ?? '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');

  const stripHtml = (value) => {
    const raw = String(value ?? '');
    if (!raw) return '';
    if (typeof DOMParser === 'function' && /<[^>]+>/.test(raw)) {
      const doc = new DOMParser().parseFromString(`<div>${raw}</div>`, 'text/html');
      return text(doc.body.textContent || '');
    }
    return text(raw);
  };

  const unwrap = (value) => {
    if (value && typeof value === 'object' && hasOwn(value, 'value')) {
      return unwrap(value.value);
    }
    return value;
  };

  const normalizeKey = (key) => text(key).toLowerCase().replace(/[\s_-]+/g, '');

  const readKey = (obj, key) => {
    if (!obj || typeof obj !== 'object') return undefined;
    if (hasOwn(obj, key)) return unwrap(obj[key]);
    const needle = normalizeKey(key);
    for (const candidate of Object.keys(obj)) {
      if (normalizeKey(candidate) === needle) {
        return unwrap(obj[candidate]);
      }
    }
    return undefined;
  };

  const isPresent = (value) => {
    if (value === null || value === undefined) return false;
    if (typeof value === 'number') return Number.isFinite(value);
    if (typeof value === 'boolean') return true;
    if (Array.isArray(value)) return value.length > 0;
    if (typeof value === 'object') return Object.keys(value).length > 0;
    return text(value) !== '';
  };

  const pick = (obj, keys, fallback = null) => {
    for (const key of keys) {
      const value = readKey(obj, key);
      if (isPresent(value)) return value;
    }
    return fallback;
  };

  const pickNumber = (obj, keys, fallback = Number.NaN) => {
    const value = pick(obj, keys, fallback);
    const parsed = Number.parseFloat(String(value ?? '').replace(/[^0-9.-]/g, ''));
    return Number.isFinite(parsed) ? parsed : fallback;
  };

  const toArray = (value) => {
    const unwrapped = unwrap(value);
    if (Array.isArray(unwrapped)) return unwrapped;
    if (unwrapped === null || unwrapped === undefined) return [];
    if (typeof unwrapped === 'string') {
      const raw = unwrapped.trim();
      if (!raw) return [];
      if (raw.startsWith('[') && raw.endsWith(']')) {
        try {
          const parsed = JSON.parse(raw);
          return Array.isArray(parsed) ? parsed : [];
        } catch (_error) {
          return [];
        }
      }
      return [raw];
    }
    return [unwrapped];
  };

  const splitList = (value) => {
    if (Array.isArray(value)) {
      return value.map((entry) => stripHtml(entry)).filter(Boolean);
    }
    const raw = String(unwrap(value) ?? '').trim();
    if (!raw) return [];
    if (/^(\[).*(\])$/s.test(raw)) {
      try {
        const parsed = JSON.parse(raw);
        if (Array.isArray(parsed)) return parsed.map((entry) => stripHtml(entry)).filter(Boolean);
      } catch (_error) {}
    }
    if (/<li[\s>]/i.test(raw) && typeof DOMParser === 'function') {
      const doc = new DOMParser().parseFromString(`<div>${raw}</div>`, 'text/html');
      const items = Array.from(doc.querySelectorAll('li'))
        .map((item) => stripHtml(item.textContent))
        .filter(Boolean);
      if (items.length) return items;
    }
    return raw
      .split(/\r?\n|\|/g)
      .map((entry) => stripHtml(entry))
      .filter(Boolean);
  };

  const parseDate = (value) => {
    const raw = text(value);
    if (!raw) return null;
    const asDate = new Date(raw);
    return Number.isNaN(asDate.getTime()) ? null : asDate;
  };

  const addDays = (date, days) => {
    if (!(date instanceof Date)) return null;
    const clone = new Date(date.getTime());
    clone.setUTCDate(clone.getUTCDate() + days);
    return clone;
  };

  const formatDate = (value) => {
    const date = value instanceof Date ? value : parseDate(value);
    if (!date) return '--';
    return date.toLocaleDateString(undefined, {
      year: 'numeric',
      month: 'short',
      day: '2-digit',
      timeZone: 'UTC',
    });
  };

  const formatDateShort = (value) => {
    const date = value instanceof Date ? value : parseDate(value);
    if (!date) return '--';
    return date.toLocaleDateString(undefined, {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      timeZone: 'UTC',
    });
  };

  const formatDateTime = (dateValue, timeValue) => {
    const date = parseDate(dateValue);
    const fallbackTime = text(timeValue);
    if (!date) return fallbackTime || '--';
    const time = fallbackTime || date.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit', timeZone: 'UTC' });
    return `${formatDate(date)} ${time}`;
  };

  const dedupeStrings = (items) => {
    const seen = new Set();
    return items
      .map((item) => text(item))
      .filter(Boolean)
      .filter((item) => {
        const key = item.toLowerCase();
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      });
  };

  const dedupeBy = (items, selector) => {
    const seen = new Set();
    return items.filter((item) => {
      const key = selector(item);
      if (!key) return false;
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });
  };

  // ══════════════════════════════════════════════════════════════════════════
  // DATA MODEL BUILDING
  // ══════════════════════════════════════════════════════════════════════════

  const buildGuestModel = (guest, index) => {
    const personalInfo = pick(guest, ['personal_info', 'personalInfo'], {}) || {};
    const requirements = pick(guest, ['requirements'], {}) || {};
    const constraints = toArray(pick(guest, ['constraints']));
    const psychographics = pick(guest, ['psychographics'], {}) || {};

    const dietaryReqs = constraints.filter(c => {
      const type = text(pick(c, ['type'])).toUpperCase();
      return type === 'DIETARY';
    });

    const mobilityReqs = constraints.filter(c => {
      const type = text(pick(c, ['type'])).toUpperCase();
      return type === 'MOBILITY' || type === 'MEDICAL';
    });

    return {
      id: text(pick(guest, ['guest_id', 'guestId', 'id'])) || `guest-${index + 1}`,
      displayName: text(pick(personalInfo, ['display_name', 'displayName', 'name'])) ||
                   text(pick(guest, ['name', 'full_name', 'fullName'])) ||
                   `Guest ${index + 1}`,
      role: text(pick(personalInfo, ['role'])) || 'Traveller',
      nationality: text(pick(personalInfo, ['nationality', 'country'])),
      dietaryRequirements: dietaryReqs.map(c => ({
        description: text(pick(c, ['description'])),
        severity: text(pick(c, ['severity'])) || 'normal',
        notes: text(pick(c, ['notes', 'operational_notes']))
      })),
      mobilityRequirements: mobilityReqs.map(c => ({
        description: text(pick(c, ['description'])),
        severity: text(pick(c, ['severity'])) || 'normal',
        notes: text(pick(c, ['operational_notes', 'notes']))
      })),
      interests: toArray(pick(psychographics, ['interests'])),
      constraints: constraints
    };
  };

  const buildPropertyModel = (segment, index) => {
    const property = pick(segment, ['property'], {}) || {};
    const accommodation = pick(segment, ['accommodation'], {}) || {};
    const dates = pick(segment, ['dates'], {}) || {};
    const transit = pick(segment, ['transit'], {}) || {};

    return {
      index: index + 1,
      name: text(pick(property, ['name'])) ||
            text(pick(segment, ['title', 'name', 'accommodation_name'])) ||
            `Property ${index + 1}`,
      pinId: text(pick(property, ['pin_id', 'pinId', 'wetu_id'])),
      startDate: text(pick(dates, ['start', 'start_date', 'startDate'])) ||
                 text(pick(segment, ['start_date', 'startDate'])),
      endDate: text(pick(dates, ['end', 'end_date', 'endDate'])) ||
               text(pick(segment, ['end_date', 'endDate'])),
      reservationsPhone: text(pick(property, ['reservations_phone', 'phone', 'telephone'])) || 'TBC',
      reservationsEmail: text(pick(property, ['reservations_email', 'email'])) || 'TBC',
      contactName: text(pick(property, ['contact_name', 'contact'])) || 'TBC',
      bookingReference: text(pick(accommodation, ['booking_reference', 'bookingReference', 'reference'])) || 'Pending confirmation',
      roomType: text(pick(accommodation, ['room_type', 'roomType'])) || 'TBC',
      roomCount: pickNumber(accommodation, ['room_count', 'roomCount', 'rooms'], 1),
      checkInTime: text(pick(accommodation, ['check_in_time', 'checkInTime'])) || '14:00',
      checkOutTime: text(pick(accommodation, ['check_out_time', 'checkOutTime'])) || '10:00',
      mealBasis: text(pick(accommodation, ['meal_basis', 'mealBasis', 'board_basis'])) || 'TBC',
      drinksBasis: text(pick(accommodation, ['drinks_basis', 'drinksBasis'])) || 'TBC',
      region: text(pick(property, ['region', 'location', 'area']))
    };
  };

  const buildTransferModel = (transit, segmentIndex) => {
    if (!transit || typeof transit !== 'object') return null;

    const mode = text(pick(transit, ['mode', 'type'])).toUpperCase() || 'TRANSFER';
    const details = pick(transit, ['details'], {}) || {};

    return {
      segmentNumber: segmentIndex + 1,
      mode: mode,
      duration: text(pick(transit, ['duration', 'travel_time'])) || 'TBC',
      distance: text(pick(transit, ['distance'])) || 'TBC',
      source: text(pick(transit, ['source'])) || 'Estimate',
      departureTime: text(pick(details, ['departure_time', 'departureTime', 'start_time'])) || 'TBC',
      arrivalTime: text(pick(details, ['arrival_time', 'arrivalTime', 'end_time'])) || 'TBC',
      vehicle: text(pick(details, ['vehicle', 'vehicle_type'])) || 'TBC',
      operator: text(pick(details, ['operator', 'provider', 'company'])) || 'TBC',
      flightCode: text(pick(details, ['flight_code', 'flightCode', 'flight_number'])),
      terminals: text(pick(details, ['terminals'])),
      notes: text(pick(transit, ['notes', 'description'])),
      roadConditions: text(pick(transit, ['road_conditions', 'roadConditions'])),
      warnings: toArray(pick(transit, ['warnings']))
    };
  };

  const buildOpsModel = (data, root) => {
    const opsView = pick(data, ['ops_view', 'opsView'], {}) || {};
    const customerView = pick(data, ['customer_view', 'customerView'], {}) || {};
    const dossierView = pick(data, ['dossier_view', 'dossierView'], {}) || {};
    const hero = pick(customerView, ['hero'], {}) || {};
    const partyOverview = pick(customerView, ['party_overview', 'partyOverview'], {}) || {};
    const routingSegments = toArray(pick(opsView, ['routing_segments', 'routingSegments']));
    const properties = toArray(pick(opsView, ['property_contacts', 'propertyContacts'])).map((property, index) => {
      const supplierContact = pick(property, ['supplier_contact', 'supplierContact'], {}) || {};
      const mappedProperty = {
        index: index + 1,
        segmentId: text(pick(property, ['segment_id', 'segmentId'])),
        name: text(pick(property, ['property_name', 'propertyName'])) || `Property ${index + 1}`,
        location: text(pick(property, ['location'])),
        bookingReference: text(pick(property, ['booking_reference', 'bookingReference'])) || 'Pending confirmation',
        roomType: text(pick(property, ['room_type', 'roomType'])) || '--',
        roomCount: pickNumber(property, ['room_count', 'roomCount'], NaN),
        contactName: text(pick(supplierContact, ['name', 'contact_name', 'contactName'])) || '--',
        reservationsEmail: text(pick(supplierContact, ['email'])) || '--',
        reservationsPhone: text(pick(supplierContact, ['phone', 'telephone'])) || '--',
      };
      const hasPropertyName = text(pick(property, ['property_name', 'propertyName']));
      const hasReservationData = Boolean(
        hasPropertyName ||
        text(pick(property, ['booking_reference', 'bookingReference'])) ||
        text(pick(property, ['room_type', 'roomType'])) ||
        pickNumber(property, ['room_count', 'roomCount'], 0) > 0
      );
      return hasReservationData ? mappedProperty : null;
    }).filter(Boolean);
    const transfers = routingSegments.map((segment, index) => ({
      segmentNumber: index + 1,
      segmentId: text(pick(segment, ['segment_id', 'segmentId'])),
      startDate: text(pick(segment, ['start_date', 'startDate'])),
      endDate: text(pick(segment, ['end_date', 'endDate'])),
      mode: text(pick(segment, ['mode'])) || 'transfer',
      durationMinutes: pickNumber(segment, ['duration_minutes', 'durationMinutes'], NaN),
      departureTime: text(pick(segment, ['departure_time', 'departureTime'])) || '--',
      arrivalTime: text(pick(segment, ['arrival_time', 'arrivalTime'])) || '--',
      meetingInstructions: text(pick(segment, ['meeting_instructions', 'meetingInstructions'])),
      drivingNotes: text(pick(segment, ['driving_notes', 'drivingNotes'])),
    }));
    const startDate = parseDate(pick(hero, ['start_date', 'startDate']) || pick(data, ['start_date', 'startDate', 'StartDate']));
    const endDate = parseDate(pick(hero, ['end_date', 'endDate']) || pick(data, ['end_date', 'endDate', 'EndDate']));
    const routeWarnings = transfers.map((segment) => segment.drivingNotes).filter(Boolean);
    const totalNights = pickNumber(hero, ['night_count', 'nightCount'], properties.length);
    const paxCount = pickNumber(partyOverview, ['total_travellers', 'totalTravellers'], NaN) || pickNumber(data, ['pax', 'travellers_adult', 'adults'], 0);

    return {
      referenceNumber: text(pick(data, ['identifier', 'reference_number', 'referenceNumber'])) || '--',
      classification: 'INTERNAL OPERATIONS',
      startDate,
      endDate,
      dateRange: startDate && endDate
        ? `${formatDateShort(startDate)} - ${formatDateShort(endDate)}`
        : formatDateShort(startDate),
      totalNights,
      paxCount,
      tripDirector: text(pick(data, ['trip_director', 'tripDirector'])) || 'Plekify Operations',
      properties,
      transfers,
      routeFeasibility: {
        totalDriving: `${transfers.filter((segment) => /transfer|drive/i.test(segment.mode)).length} ground sectors`,
        totalFlightTime: `${transfers.filter((segment) => /flight/i.test(segment.mode)).length} air sectors`,
        warnings: routeWarnings,
        status: routeWarnings.length === 0 ? 'Ops routing loaded from contract' : `${routeWarnings.length} route notes`,
      },
      vehicleAllocation: toArray(pick(opsView, ['vehicle_allocation', 'vehicleAllocation'])),
      dietaryLog: toArray(pick(opsView, ['dietary_confirmation_log', 'dietaryConfirmationLog'])),
      accessibilityLog: toArray(pick(opsView, ['accessibility_execution_log', 'accessibilityExecutionLog'])),
      confidentialEvents: toArray(pick(opsView, ['confidential_events', 'confidentialEvents'])),
      emergencyContacts: toArray(pick(opsView, ['emergency_contacts', 'emergencyContacts'])),
      splitDepartures: toArray(pick(opsView, ['split_departures', 'splitDepartures'])),
      operationalChecklist: toArray(pick(opsView, ['operational_checklist', 'operationalChecklist'])).filter((entry) => {
        const subject = text(pick(entry, ['subject']));
        const notes = text(pick(entry, ['notes']));
        return Boolean(subject || notes);
      }),
      commercial: pick(dossierView, ['commercial_summary', 'commercialSummary'], {}) || {},
      metadata: {
        version: text(pick(opsView, ['view_contract_version', 'viewContractVersion'])) || '2.0.0',
        audience: text(pick(opsView, ['audience'])) || 'ops',
        sourceItinerary: text(pick(hero, ['title'])) || text(pick(data, ['name', 'title'])) || '',
      },
    };
  };

  // ══════════════════════════════════════════════════════════════════════════
  // HTML RENDERING HELPERS
  // ══════════════════════════════════════════════════════════════════════════

  const kvRow = (label, value, mono = false) => {
    const v = text(String(value ?? ''));
    if (!v || v === '--' || v === 'TBC') return '';
    const cls = mono ? ' itin-ops__mono' : '';
    return `<div class="itin-ops__kv-row"><span class="itin-ops__kv-key">${escapeHtml(label)}</span><span class="itin-ops__kv-val${cls}">${escapeHtml(v)}</span></div>`;
  };

  const tableRow = (cells, isHeader = false) => {
    const tag = isHeader ? 'th' : 'td';
    return `<tr>${cells.map(c => `<${tag}>${escapeHtml(c)}</${tag}>`).join('')}</tr>`;
  };

  // ══════════════════════════════════════════════════════════════════════════
  // SECTION RENDERERS
  // ══════════════════════════════════════════════════════════════════════════

  const renderPropertyContacts = (properties) => {
    if (!properties.length) {
      return '<p class="itin-ops__empty">No property contacts available.</p>';
    }

    return properties.map((prop) => {
      const rows = [
        prop.location ? `<tr><th>Location</th><td>${escapeHtml(prop.location)}</td></tr>` : '',
        prop.reservationsPhone && prop.reservationsPhone !== '--' ? `<tr><th>Reservations phone</th><td>${escapeHtml(prop.reservationsPhone)}</td></tr>` : '',
        prop.reservationsEmail && prop.reservationsEmail !== '--' ? `<tr><th>Reservations email</th><td>${escapeHtml(prop.reservationsEmail)}</td></tr>` : '',
        prop.contactName && prop.contactName !== '--' ? `<tr><th>Contact Name</th><td>${escapeHtml(prop.contactName)}</td></tr>` : '',
        prop.bookingReference && prop.bookingReference !== 'Pending confirmation' ? `<tr><th>Booking Reference</th><td class="itin-ops__mono">${escapeHtml(prop.bookingReference)}</td></tr>` : '',
        prop.roomType && prop.roomType !== '--' ? `<tr><th>Room Type</th><td>${escapeHtml(prop.roomType)}</td></tr>` : '',
        Number.isFinite(prop.roomCount) && prop.roomCount > 0 ? `<tr><th>Room Count</th><td>${prop.roomCount}</td></tr>` : '',
      ].filter(Boolean).join('');

      return `
      <div class="itin-ops__property-card">
        <h4 class="itin-ops__property-name">${escapeHtml(prop.name)}</h4>
        <table class="itin-ops__table itin-ops__table--compact">
          <tbody>
            ${rows}
          </tbody>
        </table>
      </div>
    `;
    }).join('');
  };

  const renderTransferSummary = (routeFeasibility) => {
    return `
      <div class="itin-ops__summary-box">
        <p class="itin-ops__annot">Route Summary</p>
        <table class="itin-ops__table itin-ops__table--summary">
          <tbody>
            <tr><th>Status</th><td>${routeFeasibility.warnings.length === 0 ? '<span class="itin-ops__badge itin-ops__badge--ok">All routes valid</span>' : '<span class="itin-ops__badge itin-ops__badge--warn">' + routeFeasibility.warnings.length + ' warnings</span>'}</td></tr>
            <tr><th>Total Driving</th><td>${escapeHtml(routeFeasibility.totalDriving)}</td></tr>
            <tr><th>Total Flight Time</th><td>${escapeHtml(routeFeasibility.totalFlightTime)}</td></tr>
          </tbody>
        </table>
        ${routeFeasibility.warnings.length > 0 ? `
          <div class="itin-ops__warnings">
            <p class="itin-ops__annot">Warnings</p>
            <ul class="itin-ops__bullet-list itin-ops__bullet-list--warn">
              ${routeFeasibility.warnings.map(w => `<li>${escapeHtml(w)}</li>`).join('')}
            </ul>
          </div>
        ` : ''}
      </div>
    `;
  };

  const renderTransferSegments = (transfers) => {
    if (!transfers.length) {
      return '<p class="itin-ops__empty">No transfer segments available.</p>';
    }

    return transfers.map((t, i) => `
      <div class="itin-ops__transfer-card">
        <h4 class="itin-ops__transfer-header">Segment ${t.segmentNumber}: ${escapeHtml(t.mode.toLowerCase())}</h4>
        <table class="itin-ops__table itin-ops__table--compact">
          <tbody>
            <tr><th>Travel window</th><td>${escapeHtml(t.startDate)} - ${escapeHtml(t.endDate)}</td></tr>
            <tr><th>Mode</th><td>${escapeHtml(t.mode)}</td></tr>
            <tr><th>Duration</th><td>${Number.isFinite(t.durationMinutes) ? `${Math.round(t.durationMinutes)} min` : '--'}</td></tr>
            <tr><th>Departure</th><td>${escapeHtml(t.departureTime)}</td></tr>
            <tr><th>Arrival</th><td>${escapeHtml(t.arrivalTime)}</td></tr>
          </tbody>
        </table>
        ${t.meetingInstructions ? `<p class="itin-ops__transfer-notes"><strong>Meeting instructions:</strong> ${escapeHtml(t.meetingInstructions)}</p>` : ''}
        ${t.drivingNotes ? `<p class="itin-ops__transfer-notes"><strong>Driving notes:</strong> ${escapeHtml(t.drivingNotes)}</p>` : ''}
      </div>
    `).join('');
  };

  const renderVehicleAllocation = (entries) => {
    if (!entries.length) {
      return '<p class="itin-ops__empty">No vehicle allocation recorded.</p>';
    }

    return entries.map((entry) => `
      <div class="itin-ops__subsection">
        <p class="itin-ops__annot">Day ${escapeHtml(text(pick(entry, ['day'])) || '--')} · ${escapeHtml(text(pick(entry, ['activity'])) || 'Vehicle plan')}</p>
        <table class="itin-ops__table itin-ops__table--compact">
          <thead>
            <tr>
              <th>Vehicle</th>
              <th>Guests</th>
              <th>Notes</th>
            </tr>
          </thead>
          <tbody>
            ${toArray(pick(entry, ['vehicles'])).map((vehicle) => `
              <tr>
                <td>${escapeHtml(text(pick(vehicle, ['vehicle_id', 'vehicleId'])) || '--')}</td>
                <td>${escapeHtml(toArray(pick(vehicle, ['guests'])).map(text).filter(Boolean).join(', ') || '--')}</td>
                <td>${escapeHtml(text(pick(vehicle, ['notes'])) || '--')}</td>
              </tr>
            `).join('')}
          </tbody>
        </table>
      </div>
    `).join('');
  };

  const renderDietaryMatrix = (entries) => {
    if (!entries.length) {
      return '<p class="itin-ops__empty">No special dietary requirements recorded.</p>';
    }

    return `
      <div class="itin-ops__subsection">
        <p class="itin-ops__annot">Guest Dietary Summary</p>
        <table class="itin-ops__table itin-ops__table--dietary">
          <thead>
            <tr>
              <th>Property</th>
              <th>Guest</th>
              <th>Requirement</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            ${entries.map((entry) => `
              <tr>
                <td>${escapeHtml(text(pick(entry, ['property'])) || '--')}</td>
                <td>${escapeHtml(text(pick(entry, ['guest'])) || '--')}</td>
                <td>${escapeHtml(text(pick(entry, ['requirement'])) || '--')}</td>
                <td><span class="itin-ops__severity itin-ops__severity--${escapeHtml(text(pick(entry, ['severity'])) || 'normal')}">${escapeHtml(text(pick(entry, ['status'])) || '--')}</span></td>
              </tr>
            `).join('')}
          </tbody>
        </table>
      </div>
    `;
  };

  const renderChefChecklist = (entries) => {
    if (!entries.length) {
      return '';
    }

    return `
      <div class="itin-ops__subsection">
        <p class="itin-ops__annot">Confirmation Notes</p>
        <ul class="itin-ops__checklist">
          ${entries.map((entry, index) => `
            <li class="itin-ops__checklist-item">
              <input type="checkbox" id="chef-${index}" class="itin-ops__checkbox" ${text(pick(entry, ['status'])).includes('confirmed') ? 'checked' : ''}>
              <label for="chef-${index}"><strong>${escapeHtml(text(pick(entry, ['confirmed_by'])) || text(pick(entry, ['property'])) || 'Supplier')}</strong> - ${escapeHtml(text(pick(entry, ['notes'])) || text(pick(entry, ['confirmation_method'])) || 'Confirmation note recorded')}</label>
            </li>
          `).join('')}
        </ul>
      </div>
    `;
  };

  const renderAccessibility = (entries) => {
    if (!entries.length) {
      return '<p class="itin-ops__empty">No accessibility provisions required.</p>';
    }

    return `
      <div class="itin-ops__subsection">
        <p class="itin-ops__annot">Accessibility provisions confirmed in the ops contract</p>
        ${entries.map((entry) => `
          <div class="itin-ops__accessibility-card">
            <h4 class="itin-ops__guest-name">${escapeHtml(text(pick(entry, ['guest_id', 'guestId'])) || '--')}</h4>
            <p class="itin-ops__note-inline">${escapeHtml(text(pick(entry, ['location'])) || '--')}</p>
            <ul class="itin-ops__bullet-list">
              <li>${escapeHtml(text(pick(entry, ['provision'])) || '--')}</li>
              <li>Status: ${escapeHtml(text(pick(entry, ['status'])) || '--')}</li>
            </ul>
          </div>
        `).join('')}
      </div>
    `;
  };

  const renderConfidentialEvents = (entries) => {
    if (!entries.length) {
      return '<p class="itin-ops__empty">No confidential event logic recorded.</p>';
    }

    return entries.map((entry) => `
      <div class="itin-ops__subsection">
        <p class="itin-ops__annot">${escapeHtml(text(pick(entry, ['event_type', 'eventType'])) || 'Confidential event')} · ${escapeHtml(text(pick(entry, ['date'])) || '--')}</p>
        <table class="itin-ops__table itin-ops__table--compact">
          <tbody>
            <tr><th>Participants</th><td>${escapeHtml(toArray(pick(entry, ['participants'])).map(text).filter(Boolean).join(', ') || '--')}</td></tr>
            <tr><th>Access scope</th><td>${escapeHtml(text(pick(entry, ['confidentiality_level', 'confidentialityLevel'])) || '--')}</td></tr>
            <tr><th>Staff access</th><td>${escapeHtml(toArray(pick(entry, ['staff_access_list', 'staffAccessList'])).map(text).filter(Boolean).join(', ') || '--')}</td></tr>
          </tbody>
        </table>
        ${toArray(pick(entry, ['logistics_checklist', 'logisticsChecklist'])).length ? `
          <ul class="itin-ops__bullet-list">
            ${toArray(pick(entry, ['logistics_checklist', 'logisticsChecklist'])).map((item) => `<li>${escapeHtml(text(item))}</li>`).join('')}
          </ul>
        ` : ''}
      </div>
    `).join('');
  };

  const renderEmergencyServices = (entries) => {
    if (!entries.length) {
      return '<p class="itin-ops__empty">No emergency services contacts available.</p>';
    }

    return entries.map((region) => {
      const serviceList = toArray(pick(region, ['services']));
      if (!serviceList.length) return '';
      const regionName = text(pick(region, ['region'])) || 'Region';

      return `
        <div class="itin-ops__emergency-region">
          <h4 class="itin-ops__region-name">${escapeHtml(regionName)}</h4>
          <table class="itin-ops__table itin-ops__table--emergency">
            <thead>
              <tr>
                <th>Type</th>
                <th>Name</th>
                <th>Phone</th>
                <th>Notes</th>
              </tr>
            </thead>
            <tbody>
              ${serviceList.map(svc => `
                <tr>
                  <td>${escapeHtml(text(pick(svc, ['type'])))}</td>
                  <td>${escapeHtml(text(pick(svc, ['name'])))}</td>
                  <td class="itin-ops__mono">${escapeHtml(text(pick(svc, ['phone', 'telephone'])))}</td>
                  <td>${escapeHtml(text(pick(svc, ['notes'])))}</td>
                </tr>
              `).join('')}
            </tbody>
          </table>
        </div>
      `;
    }).join('');
  };

  const renderSplitDepartures = (entries) => {
    if (!entries.length) {
      return '<p class="itin-ops__empty">No split departure logic recorded.</p>';
    }

    return entries.map((entry) => `
      <div class="itin-ops__subsection">
        <p class="itin-ops__annot">${escapeHtml(text(pick(entry, ['group_label', 'groupLabel'])) || 'Departure group')}</p>
        <table class="itin-ops__table itin-ops__table--compact">
          <tbody>
            <tr><th>Guests</th><td>${escapeHtml(toArray(pick(entry, ['guests'])).map(text).filter(Boolean).join(', ') || '--')}</td></tr>
            <tr><th>Destination</th><td>${escapeHtml(text(pick(entry, ['destination'])) || '--')}</td></tr>
            <tr><th>Departure</th><td>${escapeHtml(text(pick(entry, ['departure_time', 'departureTime'])) || '--')}</td></tr>
            <tr><th>Flight</th><td>${escapeHtml(text(pick(entry, ['flight_details', 'flightDetails'])) || '--')}</td></tr>
            <tr><th>Vehicle</th><td>${escapeHtml(text(pick(entry, ['transfer_vehicle', 'transferVehicle'])) || '--')}</td></tr>
          </tbody>
        </table>
        ${text(pick(entry, ['special_notes', 'specialNotes'])) ? `<p class="itin-ops__note-inline">${escapeHtml(text(pick(entry, ['special_notes', 'specialNotes'])))}</p>` : ''}
      </div>
    `).join('');
  };

  const renderOperationalChecklist = (entries) => {
    if (!entries.length) {
      return '<p class="itin-ops__empty">No operational checklist items recorded.</p>';
    }

    return `
      <ul class="itin-ops__checklist">
        ${entries.map((entry, index) => `
          <li class="itin-ops__checklist-item">
            <input type="checkbox" id="ops-check-${index}" class="itin-ops__checkbox" ${text(pick(entry, ['status'])).includes('confirmed') || text(pick(entry, ['status'])) === 'planned' ? 'checked' : ''}>
            <label for="ops-check-${index}">
              <strong>${escapeHtml(text(pick(entry, ['area'])) || 'Ops')}</strong> ·
              ${escapeHtml(text(pick(entry, ['subject'])) || '--')} ·
              ${escapeHtml(text(pick(entry, ['status'])) || '--')}
              ${text(pick(entry, ['notes'])) ? ` — ${escapeHtml(text(pick(entry, ['notes'])))}` : ''}
            </label>
          </li>
        `).join('')}
      </ul>
    `;
  };

  const renderQmdEvidence = (qmdEvidence, propertyMatchConfidence) => {
    const searchSummary = pick(qmdEvidence, ['search_summary', 'searchSummary'], {}) || {};
    const hasSearchSummary = Object.keys(searchSummary).length > 0;
    const hasPropertyMatch = propertyMatchConfidence.length > 0;

    if (!hasSearchSummary && !hasPropertyMatch) {
      return '<p class="itin-ops__empty">No QMD evidence citations available.</p>';
    }

    let html = '';

    if (hasSearchSummary) {
      html += `
        <div class="itin-ops__subsection">
          <p class="itin-ops__annot">Search Summary</p>
          <table class="itin-ops__table itin-ops__table--summary">
            <tbody>
              <tr><th>Collections Searched</th><td>${escapeHtml(text(pick(searchSummary, ['collections_searched', 'collectionsSearched'])))}</td></tr>
              <tr><th>Total Queries</th><td>${pickNumber(searchSummary, ['total_queries', 'totalQueries'], 0)}</td></tr>
              <tr><th>Average Confidence</th><td>${pickNumber(searchSummary, ['average_confidence', 'averageConfidence'], 0).toFixed(2)}</td></tr>
              <tr><th>Constraint Pass Rate</th><td>${text(pick(searchSummary, ['constraint_pass_rate', 'constraintPassRate']))}</td></tr>
              <tr><th>Trace File</th><td class="itin-ops__mono">${escapeHtml(text(pick(searchSummary, ['trace_file', 'traceFile'])))}</td></tr>
            </tbody>
          </table>
        </div>
      `;
    }

    if (hasPropertyMatch) {
      html += `
        <div class="itin-ops__subsection">
          <p class="itin-ops__annot">Property Match Confidence</p>
          <table class="itin-ops__table itin-ops__table--qmd">
            <thead>
              <tr>
                <th>Property</th>
                <th>Wetu</th>
                <th>Google</th>
                <th>Website</th>
                <th>Confidence</th>
                <th>Evidence</th>
              </tr>
            </thead>
            <tbody>
              ${propertyMatchConfidence.map(prop => `
                <tr>
                  <td>${escapeHtml(text(pick(prop, ['property', 'name'])))}</td>
                  <td>${pick(prop, ['wetu']) ? '<span class="itin-ops__check">Y</span>' : '<span class="itin-ops__cross">-</span>'}</td>
                  <td>${escapeHtml(text(pick(prop, ['google'])))}</td>
                  <td>${pick(prop, ['website']) ? '<span class="itin-ops__check">Y</span>' : '<span class="itin-ops__cross">-</span>'}</td>
                  <td>${escapeHtml(text(pick(prop, ['confidence'])))}</td>
                  <td class="itin-ops__mono">${escapeHtml(text(pick(prop, ['evidence'])))}</td>
                </tr>
              `).join('')}
            </tbody>
          </table>
        </div>
      `;
    }

    return html;
  };

  const renderRouteValidation = (routeValidation) => {
    if (!routeValidation.length) {
      return '<p class="itin-ops__empty">No route validation data available.</p>';
    }

    return `
      <p class="itin-ops__annot itin-ops__annot--italic">Transfer distances and durations validated via Mapbox Directions API.</p>
      <table class="itin-ops__table itin-ops__table--routes">
        <thead>
          <tr>
            <th>Route</th>
            <th>Validated Distance</th>
            <th>Validated Duration</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          ${routeValidation.map(route => `
            <tr>
              <td>${escapeHtml(text(pick(route, ['route', 'name'])))}</td>
              <td>${escapeHtml(text(pick(route, ['validated_distance', 'validatedDistance', 'distance'])))}</td>
              <td>${escapeHtml(text(pick(route, ['validated_duration', 'validatedDuration', 'duration'])))}</td>
              <td>${escapeHtml(text(pick(route, ['status'])))}</td>
            </tr>
          `).join('')}
        </tbody>
      </table>
    `;
  };

  const renderPricing = (commercial) => {
    const lineTotals = toArray(pick(commercial, ['line_totals', 'lineTotals']));
    const grandTotal = pick(commercial, ['grand_total', 'grandTotal'], {}) || {};
    const currency = text(pick(grandTotal, ['currency'])) || 'ZAR';
    const amount = text(pick(grandTotal, ['amount']));

    if (!lineTotals.length && !amount) {
      return '<p class="itin-ops__empty">Pricing details not available in this view.</p>';
    }

    let html = '';

    if (lineTotals.length) {
      html += `
        <div class="itin-ops__subsection">
          <p class="itin-ops__annot">Line Totals</p>
          <table class="itin-ops__table itin-ops__table--pricing">
            <thead>
              <tr>
                <th>Description</th>
                <th>Quantity</th>
                <th>Unit Price</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              ${lineTotals.map(line => `
                <tr>
                  <td>${escapeHtml(text(pick(line, ['description', 'item', 'name'])))}</td>
                  <td>${escapeHtml(text(pick(line, ['quantity', 'qty'])))}</td>
                  <td>${escapeHtml(text(pick(line, ['unit_price', 'unitPrice', 'rate'])))}</td>
                  <td>${escapeHtml(text(pick(line, ['total', 'amount'])))}</td>
                </tr>
              `).join('')}
            </tbody>
          </table>
        </div>
      `;
    }

    if (amount) {
      html += `
        <div class="itin-ops__summary-box itin-ops__summary-box--total">
          <p class="itin-ops__annot">Grand Total</p>
          <p class="itin-ops__grand-total">${escapeHtml(currency)} ${escapeHtml(amount)}</p>
        </div>
      `;
    }

    return html;
  };

  const renderTimeline = (model) => {
    // Use properties as day markers for simplified timeline
    if (!model.properties.length) {
      return '<p class="itin-ops__empty">No timeline data available.</p>';
    }

    return model.properties.map((prop, index) => `
      <article class="itin-ops__day">
        <header class="itin-ops__day-head">
          <h3 class="itin-ops__day-title">Leg ${String(index + 1).padStart(2, '0')}: ${escapeHtml(prop.name)}</h3>
          <p class="itin-ops__day-subtitle">${escapeHtml(prop.startDate)} - ${escapeHtml(prop.endDate)}</p>
          ${prop.region ? `<p class="itin-ops__day-location">${escapeHtml(prop.region)}</p>` : ''}
        </header>
        <div class="itin-ops__day-section">
          <p class="itin-ops__annot">Accommodation</p>
          <div class="itin-ops__kv">
            ${kvRow('Room Type', prop.roomType)}
            ${kvRow('Rooms', prop.roomCount)}
            ${kvRow('Check-in', prop.checkInTime)}
            ${kvRow('Check-out', prop.checkOutTime)}
            ${kvRow('Meal Basis', prop.mealBasis)}
            ${kvRow('Booking Ref', prop.bookingReference, true)}
          </div>
        </div>
        ${model.transfers[index] ? `
          <div class="itin-ops__day-section">
            <p class="itin-ops__annot">Transfer to next destination</p>
            <div class="itin-ops__kv">
              ${kvRow('Mode', model.transfers[index].mode)}
              ${kvRow('Duration', model.transfers[index].duration)}
              ${kvRow('Vehicle', model.transfers[index].vehicle)}
              ${kvRow('Operator', model.transfers[index].operator)}
            </div>
          </div>
        ` : ''}
      </article>
    `).join('');
  };

  const renderFooterMeta = (metadata) => {
    const version = text(pick(metadata, ['document_version', 'documentVersion', 'version'])) || '2.0.0';
    const generated = text(pick(metadata, ['generated', 'generated_at', 'generatedAt'])) || new Date().toISOString();
    const generator = text(pick(metadata, ['generator', 'audience'])) || 'Plekify Ops Brief Renderer';
    const sourceItinerary = text(pick(metadata, ['source_itinerary', 'sourceItinerary']));

    return `
      <dl class="itin-ops__footer-grid">
        <div class="itin-ops__footer-item"><dt>Document Version</dt><dd>${escapeHtml(version)}</dd></div>
        <div class="itin-ops__footer-item"><dt>Generated</dt><dd>${escapeHtml(generated)}</dd></div>
        <div class="itin-ops__footer-item"><dt>Generator</dt><dd>${escapeHtml(generator)}</dd></div>
        ${sourceItinerary ? `<div class="itin-ops__footer-item"><dt>Source Itinerary</dt><dd class="itin-ops__mono">${escapeHtml(sourceItinerary)}</dd></div>` : ''}
      </dl>
    `;
  };

  // ══════════════════════════════════════════════════════════════════════════
  // MAIN RENDER ORCHESTRATION
  // ══════════════════════════════════════════════════════════════════════════

  const setTextContent = (root, selector, value) => {
    const node = root.querySelector(selector);
    if (node) node.textContent = text(value) || '--';
  };

  const setStatus = (root, state, message) => {
    const node = root.querySelector('[data-ops-status]');
    if (!node) return;
    node.dataset.state = state;
    node.textContent = text(message);
  };

  const setPanelVisibility = (root, panelName, isVisible) => {
    const panel = root.querySelector(`[data-ops-panel="${panelName}"]`);
    if (!panel) return;
    panel.hidden = !isVisible;
  };

  const renumberVisiblePanels = (root) => {
    const panels = Array.from(root.querySelectorAll('[data-ops-panel]')).filter((panel) => !panel.hidden);
    panels.forEach((panel, index) => {
      const label = panel.querySelector('.itin-ops__section-label');
      if (!label) return;
      const baseText = (label.dataset.baseLabel || label.textContent || '').replace(/^\d+\.\s*/, '').trim();
      label.dataset.baseLabel = baseText;
      label.textContent = `${index + 1}. ${baseText}`;
    });
  };

  const renderModel = (root, model, sourceLabel) => {
    // Update header
    setTextContent(root, '[data-ops-reference-number]', model.referenceNumber);
    setTextContent(root, '[data-ops-classification]', model.classification);
    setTextContent(root, '[data-ops-date-range]', model.dateRange);
    setTextContent(root, '[data-ops-total-nights]', model.totalNights);
    setTextContent(root, '[data-ops-pax]', model.paxCount);
    setTextContent(root, '[data-ops-trip-director]', model.tripDirector);
    setTextContent(
      root,
      '[data-ops-header-meta]',
      `Loaded from ${sourceLabel} | ${model.totalNights} nights | ${model.paxCount} pax`
    );

    // 1. Property Contacts
    const propertyContacts = root.querySelector('[data-ops-property-contacts]');
    if (propertyContacts) propertyContacts.innerHTML = renderPropertyContacts(model.properties);

    // 2. Transfer Logistics
    const transferSummary = root.querySelector('[data-ops-transfer-summary]');
    if (transferSummary) transferSummary.innerHTML = renderTransferSummary(model.routeFeasibility);

    const transferSegments = root.querySelector('[data-ops-transfer-segments]');
    if (transferSegments) transferSegments.innerHTML = renderTransferSegments(model.transfers);

    // 3. Vehicle Allocation
    setPanelVisibility(root, 'vehicle-allocation', model.vehicleAllocation.length > 0);
    const vehicleAllocation = root.querySelector('[data-ops-vehicle-allocation]');
    if (vehicleAllocation) vehicleAllocation.innerHTML = renderVehicleAllocation(model.vehicleAllocation);

    // 4. Dietary Requirements
    const dietaryMatrix = root.querySelector('[data-ops-dietary-matrix]');
    if (dietaryMatrix) dietaryMatrix.innerHTML = renderDietaryMatrix(model.dietaryLog);

    const chefChecklist = root.querySelector('[data-ops-chef-checklist]');
    if (chefChecklist) chefChecklist.innerHTML = renderChefChecklist(model.dietaryLog);

    // 5. Accessibility
    const accessibility = root.querySelector('[data-ops-accessibility]');
    if (accessibility) accessibility.innerHTML = renderAccessibility(model.accessibilityLog);

    // 6. Confidential Event Logic
    setPanelVisibility(root, 'confidential', model.confidentialEvents.length > 0);
    const confidential = root.querySelector('[data-ops-confidential]');
    if (confidential) confidential.innerHTML = renderConfidentialEvents(model.confidentialEvents);

    // 7. Emergency Services
    const emergency = root.querySelector('[data-ops-emergency]');
    if (emergency) emergency.innerHTML = renderEmergencyServices(model.emergencyContacts);

    // 8. Split departures
    setPanelVisibility(root, 'split-departures', model.splitDepartures.length > 0);
    const splitDepartures = root.querySelector('[data-ops-split-departures]');
    if (splitDepartures) splitDepartures.innerHTML = renderSplitDepartures(model.splitDepartures);

    // 9. Operational checklist
    const checklist = root.querySelector('[data-ops-checklist]');
    if (checklist) checklist.innerHTML = renderOperationalChecklist(model.operationalChecklist);

    // Footer
    const footerMeta = root.querySelector('[data-ops-footer-meta]');
    if (footerMeta) footerMeta.innerHTML = renderFooterMeta(model.metadata);

    renumberVisiblePanels(root);
  };

  // ══════════════════════════════════════════════════════════════════════════
  // DATA FETCHING
  // ══════════════════════════════════════════════════════════════════════════

  const parseJsonLoose = (raw) => {
    const clean = String(raw ?? '').replace(/^\uFEFF/, '').trim();
    if (!clean) return null;
    try {
      return JSON.parse(clean);
    } catch (_error) {}
    if (typeof DOMParser === 'function') {
      const doc = new DOMParser().parseFromString(clean, 'text/html');
      const pre = doc.querySelector('pre');
      if (pre) {
        try {
          return JSON.parse((pre.textContent || '').trim());
        } catch (_error) {}
      }
    }
    return null;
  };

  const fetchItineraryJson = async (url) => {
    const target = text(url);
    if (!target) return null;
    const response = await fetch(target, { credentials: 'omit' });
    if (!response.ok) {
      throw new Error(`Failed request (${response.status}) for ${target}`);
    }
    const payload = parseJsonLoose(await response.text());
    if (!payload || typeof payload !== 'object') {
      throw new Error(`Invalid JSON payload at ${target}`);
    }
    if (payload.itinerary && typeof payload.itinerary === 'object') {
      return payload.itinerary;
    }
    return payload;
  };

  const fetchFromApiEndpoint = async (identifier) => {
    const id = text(identifier);
    if (!id) return null;
    const url = new URL('/apps/plekify/api/itinerary', window.location.origin);
    url.searchParams.set('identifier', id);
    url.searchParams.set('v', String(Date.now()));
    const response = await fetch(url.toString(), {
      cache: 'no-store',
      credentials: 'include'
    });
    if (!response.ok) {
      throw new Error(`API request failed (${response.status})`);
    }
    const result = await response.json();
    if (!result.success) {
      throw new Error(result.message || 'API error');
    }
    const itinerary = result.data.itinerary;
    return itinerary && typeof itinerary === 'object' ? itinerary : result.data;
  };

  const loadAndRender = async (root) => {
    const identifier = text(root.dataset.itineraryIdentifier);
    const canonicalUrl = text(root.dataset.canonicalJsonUrl);
    const fallbackUrl = text(root.dataset.fallbackJsonUrl);

    if (!identifier && !canonicalUrl && !fallbackUrl) {
      throw new Error('No itinerary data source is configured on this product.');
    }

    const attempts = [];
    if (identifier) attempts.push({ label: 'API endpoint', type: 'api', identifier });
    if (canonicalUrl) attempts.push({ label: 'canonical JSON', type: 'cdn', url: canonicalUrl });
    if (fallbackUrl) attempts.push({ label: 'fallback JSON', type: 'cdn', url: fallbackUrl });

    let payload = null;
    let sourceLabel = '';
    let errorLog = '';

    for (const attempt of attempts) {
      try {
        if (attempt.type === 'api') {
          payload = await fetchFromApiEndpoint(attempt.identifier);
        } else {
          payload = await fetchItineraryJson(attempt.url);
        }
        sourceLabel = attempt.label;
        break;
      } catch (error) {
        errorLog += `${attempt.label}: ${error.message} `;
      }
    }

    if (!payload) {
      throw new Error(text(errorLog) || 'Unable to load itinerary data.');
    }

    const model = buildOpsModel(payload, root);
    renderModel(root, model, sourceLabel);
  };

  // ══════════════════════════════════════════════════════════════════════════
  // CHROME ACTIONS (Print, Reload)
  // ══════════════════════════════════════════════════════════════════════════

  const bindChromeActions = (root) => {
    const printButton = root.querySelector('[data-ops-print]');
    if (printButton) {
      printButton.addEventListener('click', () => {
        window.print();
      });
    }

    const reloadButton = root.querySelector('[data-ops-reload]');
    if (reloadButton) {
      reloadButton.addEventListener('click', async () => {
        try {
          setStatus(root, 'loading', 'Reloading operations data...');
          await loadAndRender(root);
          setStatus(root, 'ok', 'Operations brief loaded successfully.');
        } catch (error) {
          setStatus(root, 'error', error.message || 'Unable to reload operations data.');
        }
      });
    }
  };

  // ══════════════════════════════════════════════════════════════════════════
  // INITIALIZATION
  // ══════════════════════════════════════════════════════════════════════════

  const initRoot = async (root) => {
    if (!(root instanceof HTMLElement)) return;
    if (root.dataset.opsHydrated === 'true') return;
    root.dataset.opsHydrated = 'true';
    bindChromeActions(root);
    try {
      setStatus(root, 'loading', 'Loading operations data...');
      await loadAndRender(root);
      setStatus(root, 'ok', 'Operations brief loaded successfully.');
    } catch (error) {
      setStatus(root, 'error', error.message || 'Unable to load operations data.');
    }
  };

  const boot = () => {
    document.querySelectorAll(ROOT_SELECTOR).forEach((root) => {
      initRoot(root);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const target = event.target;
    if (!(target instanceof HTMLElement)) return;
    if (target.matches(ROOT_SELECTOR)) {
      target.dataset.opsHydrated = 'false';
      initRoot(target);
      return;
    }
    target.querySelectorAll(ROOT_SELECTOR).forEach((root) => {
      root.dataset.opsHydrated = 'false';
      initRoot(root);
    });
  });
})();
  } catch(e) { console.error(e); }
})();

})();
